import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { JwtHelperService } from "@auth0/angular-jwt";

import { fromEvent, merge, Observable, Observer, of } from "rxjs";
import { catchError, delay, map, switchMap } from "rxjs/operators";
import { Moment } from "moment";

import { configuracion } from "../../../configuracion";
import { FsessionService } from "../session/fsession.service";
import { SocketService } from "../socket/socket.service";
import { SeguimientoService } from "../seguimiento/seguimiento.service";
import { MunicipalityConfigurationByUser, UsersByMunicipality, Usuario, SetUsuarioOidRequest } from "../../models/usuario";
import { Traffic, TrafficPedestrian } from "src/app/modules/traffic/components/map/map.component";
import { RespuestaSimulacionPasoCebra } from "src/app/models/paso-cebra";
import {
  calleG, CamaraG, SoporteG, VehiculoListaInteres, Group, CamerasFilteredByGroup, SettingsViewerRotating,
  Color, VehicleCountry, RouterConsumption, RoutersDataPowerAndBattery, LicensePlateDetails, EventosCam,
  LicensePlateInformation, NotificationConnection, NotificationTestBody, ResponseNotificationTest,
  VehicleDetection,
  Brand,
  SupportedLanguages,
  ConfigurationTourismPanel,
  OmitDataInConfigurationTourismPanel,
  Ticket,
  EnumStateTicket,
  GroupCamerasInConfigurationTourismPanel,
  InfoCameraAndSupportLocation,
  processedTourismPanelData,
  Tracking,
  InterestPoint,
  TrackingCategory,
  InventoryTracking,
  RouterTrackingDisabled,
  ColorByLanguage,
  PedestrianZone,
  Guardian,
  DownloadPending,
  UpdateOptionsDownload,
  TypeStorageByGetUrlImage,
  DonwnloadPendingProcessed,
  StateDownloadArchived,
  TipoEnvioInfraccion,
  CreateZarDto,
  UpdateZarDto,
  SubtypeCamera,
  SettingIsland,
  SaveSettingIsland,
  UpdateSettingIsland,
  VisorIslandConfigurationMunicipality,
  MunicipioMinimo
} from '../../models/index';
import { Parking } from "src/app/models/parking.model";
import { Regularizacion } from "src/app/modules/management/components/parking/dialogs/regularizacion/regularizacion.component";
import { InfoCamerasParking } from "src/app/modules/management/components/parking/dialogs/edit-cameras/edit-cameras.component";
import { Sort } from "@angular/material/sort";
import { ConfiguracionParking } from "src/app/modules/management/components/control-acceso-parking/control-acceso-parking.component";
import { DescargaTimelapse } from "src/app/modules/traffic/components/visordescarga-guardian/visordescarga-guardian.component";
import { CamaraZonaZar, SentidoCamara, ZonaZar } from "src/app/models/zar.model";
import { InformationToDownload } from "src/app/models/inf-personas-db.model";
import { CameraFirmware } from "src/app/models/camaraFirmware.model";
import { getTranslationProvider } from "src/app/modules/administrate/components/translations/shared/translation-provider";
import { TIPOS_INFRACCIONES } from "src/app/constants/tipos-infracciones";
import { DetectionPhotoRed, DetectionPhotoRedRequest } from "src/app/models/fotorojo";
import { Modulo, Submodulo } from "src/app/modules/administrate/components/submodulos/submodulos.component";
import { ResetAuthenticationResponse } from "src/app/modules/administrate/dialogs/reset-autenticacion-usuario/reset-autenticacion-usuario.component";
import { TraerInfraccionesPasoCebraParams, ValidacionInfraccion } from "src/app/modules/crosswalk/services/crosswalk.service";
import { DetailInfractionPhotoRed, DevicePhotoRed, PhotoRedInfraction } from "src/app/modules/red-light/services/red-light/red-light.service";

@Injectable({
  providedIn: "root",
})
export class DatabaseService {
  private http = inject(HttpClient);
  private fsession = inject(FsessionService);
  private socketService = inject(SocketService);
  private seguimiento = inject(SeguimientoService);

  httpOptions: any = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  };

  IdUsuario: number;
  IpPublica: any = "";
  serverIpPublica = configuracion.apiIpPublica;

  baseUrl = `${configuracion.servidor_api}/api`;
  UrlserviciosImg = configuracion.servidor_Img;
  UrlserviciosStream = configuracion.servidor_Stream;
  rangeEnd = configuracion.partialContentSize;
  rangeStart = 0;
  rangeString = `bytes=0-${configuracion.partialContentSize}`;

  createOnline$() {
    return merge(
      fromEvent(window, "offline").pipe(map(() => false)),
      fromEvent(window, "online").pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
  }

  Logout() {
    return this.http.post(`${this.baseUrl}/logout`, {});
  }

  updateTerms() {
    let infNav = this.getBrowserInfo();
    let ip_publica = this.IpPublica.ip;
    let current_datetime = new Date();
    return this.http.post(`${this.baseUrl}/updateTerms`, {
      infNav,
      ip_publica,
      current_datetime,
    });
  }

  TraerUsuarios(busqueda) {
    const data = {
      busqueda: busqueda,
    };
    return this.http.post(`${this.baseUrl}/usuarios`, data);
  }
  BuscarUsuarioByUsername(username) {

    return this.http.post(`${this.baseUrl}/BuscarUsuarioByUsername`, { username });
  }

  TraerUsuariosConRol(busqueda) {
    const data = {
      busqueda: busqueda,
    };
    return this.http.post(`${this.baseUrl}/usuarioConRol`, data);
  }

  /**
   * Trae una lista de usuarios
   * @param nombre nombre del usuario
   * @param municipio nombre del municipio
   * @param activo 0 para inactivos, 1 para activos, o 2 para todos
   * @param pageIndex pagina actual, desde 0
   * @param pageSize cantidad de items por pagina
   * @param sort  objeto para especificar la direccion de la ordenacion
   * @param skipPagination si es verdadero, no se aplica paginacion y se traen todos los usuarios
   * @returns Observable con la respuesta del servidor
   */
  getUsers(
    nombre: string,
    municipio: string,
    activo: number,
    pageIndex: number,
    pageSize: number,
    sort: { active: string, direction: string } = null,
    skipPagination = false
  ) {
    const data = {
      nombre,
      municipio,
      activo,
      pageIndex,
      pageSize,
      sort,
      skipPagination
    };
    return this.http.post(`${this.baseUrl}/TraerUsuarios`, data);
  }

  TraerUsuariosPorMunicipio(idmunicipio) {
    const data = {
      IdMunicipio: idmunicipio,
    };
    return this.http.post(`${this.baseUrl}/usuariosPorMunicipio`, data);
  }
  permisosSeguridad() {
    return this.http.post(`${this.baseUrl}/permisosSeguridad`, {});
  }

  TraerDetalleMunicipio(IdMunicipio) {
    const data = {
      IdMunicipio: IdMunicipio,
    };
    return this.http.post(`${this.baseUrl}/DetalleMunicipio`, data);
  }

  TraerDetalleUsusario() {
    const data = {};
    return this.http.post(`${this.baseUrl}/DetalleUsusario`, data);
  }

  validarClave(clave: any) {
    const data = {
      Clave: clave,
    };
    return this.http.post(`${this.baseUrl}/validarClave`, data);
  }

  ActualizarUsuario(supplier: any) {
    return this.http.post(`${this.baseUrl}/actualizarUsuario`, supplier);
  }

  ConfigurarIdiomaDefault(lang: string) {
    return this.http.post(`${this.baseUrl}/ConfigurarIdiomaDefault`, { lang });
  }

  generateTicketPdf(data: any) {
    const options = {
      headers: {
        Accept: "application/pdf",
      },
    };

    return this.http.post(`${this.baseUrl}/generarPdf`, data, options);
  }

  Municipios() {
    const data = {
      PalabraClave: null,
    };
    return this.http.post<{ municipios: MunicipioMinimo[], userInfo: any }>(`${this.baseUrl}/Municipios`, data);
  }

  /**
   * Trae los municipio que tienen habilitado el campo "Detecciones compartidas"
   * @param val Término de búsqueda
   * @returns Observable
   */
  MunicipiosDetecciones(val) {
    const data = {
      PalabraClave: val,
    };
    return this.http.post(`${this.baseUrl}/MunicipiosDetecciones`, data);
  }

  TMunicipios(val, cantidad) {
    const data = {
      PalabraClave: val,
      cantidadRegistros: cantidad,
    };
    return this.http.post(`${this.baseUrl}/TodosLosMunicipios`, data);
  }

  MunicipiosUsuario(IdUsuario: any = null) {
    const data = {
      IdUsuario: IdUsuario,
      PalabraClave: ''
    };

    return this.http.post(`${this.baseUrl}/MunicipiosUsuario`, data);
  }

  /**
   * Obtiene los municipios asignados al usuario junto con el rol de cada municipio.
   * @param idUsuario - ID del usuario
   * @returns
   */
  MunicipiosUsuarioConRol(idUsuario: any = null) {
    return this.http.get(`${this.baseUrl}/MunicipiosUsuarioConRol/${idUsuario}`);
  }

  ActualizarAsignacionUsuario(IdsAeliminar, IdsAagregar, IdPadre, Tipo) {
    /*
        IdPadre=puede ser el id del usuario en general si se trabaja desde el panel de usuario o el id de la instalacion en general si se trabaja desde el panel de instalaciones

        Tipo=es a aquien se va a afechar puede se USUARIO o INSTALACION(defecto)

        IdsAeliminar Y IdsAagregar +los valores van separados por comas (,)
        */
    const data = {
      IdsAeliminar: IdsAeliminar,
      IdsAagregar: IdsAagregar,
      IdPadre: IdPadre,
      Tipo: Tipo,
    };
    return this.http.post(`${this.baseUrl}/ActualizarAsignacionUsuario`, data);
  }

  UsuarioInstalaciones(IdInstalacion: any) {
    const data = {
      IdInstalacion: IdInstalacion,
    };

    return this.http.post(`${this.baseUrl}/UsuarioInstalaciones`, data);
  }

  /**
   * Metodo para guardar un nuevo usuario
   * @param Nombre nombre del usuario
   * @param tipo tipo de usuario
   * @param Usuario nombre unico
   * @param Activo bandera para determinar si esta activo o no
   * @param Email correo
   * @param IdRol id del rol
   * @param tiempo_sesion tiempo de session
   * @param municipiosagregar municipio por defecto
   * @param isSuperAdmin bandera que determina si es un superadmin o no
   * @param {string} [nameRol=''] nombre del rol a asignar
   * @returns Observable con la respuesta
   */
  GuardarUsuario(
    Nombre: string,
    tipo: number,
    Usuario: string,
    dni: number,
    Activo: boolean,
    Email: string,
    IdRol: number,
    tiempo_sesion: string,
    municipiosagregar: number,
    isSuperAdmin: 1 | 0,
    busquedaMultimunicipio: 1 | 0,
    nameRol: string = '',
    acceso_preview = 0,
    acceso_development = 0,
    fecha_caducidad_preview: Moment = null,
    fecha_caducidad_dev: Moment = null
  ) {
    const data = {
      tipo,
      Nombre: Nombre,
      Usuario: Usuario,
      dni: dni,
      Activo: Activo,
      Email: Email,
      IdRol: IdRol,
      tiempo_sesion,
      municipiosagregar,
      isSuperAdmin,
      busquedaMultimunicipio,
      nameRol,
      acceso_preview,
      acceso_development,
      fecha_caducidad_preview,
      fecha_caducidad_dev
    };
    return this.http.post(`${this.baseUrl}/GuardarUsuario`, data);
  }

  ModificarUsuario(data) {
    data.MunicipiosTmp = null;
    return this.http.post(`${this.baseUrl}/ModificarUsuario`, data);
  }

  /**
   */
  SetAzureOid(data: SetUsuarioOidRequest) {
    return this.http.post(
      `${this.baseUrl}/ActualizarUsuarioOid`,
      data
    );
  }

  VerificarUsuario(usuario, mail, skipCheckB2C = false) {
    const data = {
      Usuario: usuario,
      Mail: mail,
      skipCheckB2C
    };

    return this.http.post(`${this.baseUrl}/VerificarUsuario`, data);
  }

  /**
   * Trae los municipos dependiendo del rol del usuario 
   * @param val valor a buscar, hacer match
   * @param idUsuario id del usuario 
   * @param desde fecha inicial
   * @param hasta fecha final 
   * @param esBusquedaPorPermisoPorUsuario 
   * bandera que determina si la busqueda se hace teniendo en cuenta los permisos (municipios) que tiene el usuario 
   * @returns callback
   */
  TraerMunicipiosGenerales(
    val: any, idUsuario: number, desde: string = null, hasta: string = null, esBusquedaPorPermisoPorUsuario = false, activo = 0
  ) {
    const data = {
      PalabraClave: val,
      idUsuario,
      desde,
      hasta,
      esBusquedaPorPermisoPorUsuario,
      activo
    };
    return this.http.post(`${this.baseUrl}/InfoMunicipios`, data);
  }

  TraerMunicipiosGeneralesPorFecha(desde, hasta) {
    const data = {
      desde: desde,
      hasta: hasta,
    };
    return this.http.post(`${this.baseUrl}/InfoMunicipiosPorFecha`, data);
  }

  /**
   * Guardar nuevo municipio
   * @param Nombre nombre del municipio
   * @param Direccion direccion del municipio
   * @param Provincia privincia del municipio
   * @param CodPostal cod postal del municipio
   * @param Poblacion poblacion del municipio
   * @param Contacto contacto del municipio
   * @param Contacto2 contacto2 del municipio
   * @param Contacto3 contacto3 del municipio
   * @param Email Correo del municipio
   * @param Telefono telefono del municipio
   * @param Telefono2 telefono2 del municipio
   * @param Telefono3 telefono3 del municipio
   * @param fechaIF Fecha de instalacion
   * @param fechaIAF Fecha de instalacion acometida
   * @param CUPS CUPS
   * @param IdTarifa tarifa del municipio
   * @param Latitud latitud del municipio
   * @param Longitud longitud del municipio
   * @param usuariosAgregar Usuario que se le asigna
   * @returns 
   */
  GuardarMunicipio(
    Nombre: any,
    Direccion: any,
    Provincia: any,
    CodPostal: any,
    Poblacion: any,
    Contacto: any,
    Contacto2: any,
    Contacto3: any,
    Email: any,
    Telefono: any,
    Telefono2: any,
    Telefono3: any,
    fechaIF: any,
    fechaIAF: any,
    CUPS: any,
    IdTarifa: any,
    Latitud: any,
    Longitud: any,
    deteccionesCompartidas: any,
    Zona: any,
    usuariosAgregar: any
  ) {
    const data = {
      Nombre: Nombre,
      Direccion: Direccion,
      Provincia: Provincia,
      CodPostal: CodPostal,
      Poblacion: Poblacion,
      Contacto: Contacto,
      Contacto2: Contacto2,
      Contacto3: Contacto3,
      Email: Email,
      Telefono: Telefono,
      Telefono2: Telefono2,
      Telefono3: Telefono3,
      fechaIF: fechaIF,
      fechaIAF: fechaIAF,
      CUPS: CUPS,
      IdTarifa: IdTarifa,
      Latitud: Latitud,
      Longitud: Longitud,
      deteccionesCompartidas,
      Zona: Zona,
      usuariosAgregar: usuariosAgregar,
    };
    return this.http.post(`${this.baseUrl}/GuardarMunicipio`, data);
  }

  /**
   * Modifica un municipio
   * @param Datos datos del municipio
   * @returns Observable
   */
  ModificarMunicipio(Datos: any) {
    const idUser = this.fsession.optenerValor('idusuario');

    const data = { ...Datos }; // clonar para no afectar this.data directamente

    data.idUser = idUser;

    return this.http.post(`${this.baseUrl}/ModificarMunicipio`, data);
  }


  getZonaHoraria(filter) {
    const data = {
      filter: filter,
    };
    return this.http.post(`${this.baseUrl}/getZonaHoraria`, data);
  }

  TraerMunicipiosPorUsuarios(IdUsuario) {
    const data = {
      IdUsuario: IdUsuario,
    };
    return this.http.post(`${this.baseUrl}/MunicipioGporUsuario`, data);
  }

  /**
   * Trae listado de soportes
   * @param desde fecha de inicio de soportes
   * @param hasta fecha final de soportes
   * @param Tipo tipo de soporte
   * @param IdMunicipio id de municipio
   * @param Descripcion descripcion
   * @param pageIndex indice de la pagina actual 
   * @param pageSize numero de resultados a obtener en la busqueda
   * @returns Observable
   */
  TraerSoportesGenerales(
    desde: string,
    hasta: string,
    Tipo: any,
    IdMunicipio: number,
    Descripcion: string,
    activo: boolean,
    pageIndex: number,
    pageSize: number,
    sort: Sort,
  ): Observable<SoporteG[]> {
    const data = {
      desde,
      hasta,
      Tipo,
      activo,
      IdMunicipio,
      Descripcion,
      pageIndex,
      pageSize,
      sort
    };
    return this.http.post<SoporteG[]>(`${this.baseUrl}/InfoSoportes`, data);
  }

  TraerTiposSoporte(nombre, Activo, validateName) {
    const data = { nombre: nombre, Activo: Activo, validateName: validateName }
    return this.http.post(`${this.baseUrl}/TraerTiposSoporte`, data);
  }

  AlmacenarTiposSoporte(Nombre, Descripcion,usaPin3,usaEntrada2) {
    const data = {
      Nombre: Nombre,
      Descripcion: Descripcion,
      usaPin3: usaPin3,
      usaEntrada2: usaEntrada2
    };
    return this.http.post(`${this.baseUrl}/AgregarTipoSoporte`, data);
  }

  ModificarTipoSoporte(IdTipo, Nombre, Descripcion, usaPin3, usaEntrada2, Activo) {
    const data = {
      IdTipo: IdTipo,
      Nombre: Nombre,
      Descripcion: Descripcion,
      usaPin3: usaPin3,
      usaEntrada2: usaEntrada2,   
      Activo: Activo,
    };
    return this.http.post(`${this.baseUrl}/ModificarTipoSoporte`, data);
  }

  VerificarTipoSoporte(IdTipo) {
    const data = {
      IdTipo: IdTipo,
    };
    return this.http.post(`${this.baseUrl}/VerificarTipoSoporte`, data);
  }

  EliminarTipoSoporte(IdTipo) {
    const data = {
      IdTipo: IdTipo,
    };
    return this.http.post(`${this.baseUrl}/EliminarTipoSoporte`, data);
  }

  GuardarSoporte(
    Descripcion,
    Latitud,
    Longitud,
    IdTipo,
    IdMunicipio,
    IdCalle,
    Foto
  ) {
    const data = {
      Descripcion: Descripcion,
      Latitud: Latitud,
      Longitud: Longitud,
      IdTipo: IdTipo,
      IdMunicipio: IdMunicipio,
      IdCalle: IdCalle,
      Foto: Foto,
    };
    return this.http.post(`${this.baseUrl}/GuardarSoporte`, data);
  }

  ModificarSoporte(
    IdSoporte,
    Descripcion,
    Latitud,
    Longitud,
    IdTipo,
    IdMunicipio,
    Eliminado,
    IdCalle,
    Foto
  ) {
    const data = {
      IdSoporte: IdSoporte,
      Descripcion: Descripcion,
      Latitud: Latitud,
      Longitud: Longitud,
      IdTipo: IdTipo,
      IdMunicipio: IdMunicipio,
      Eliminado: Eliminado,
      IdCalle: IdCalle,
      Foto: Foto,
    };
    return this.http.post(`${this.baseUrl}/ModificarSoporte`, data);
  }

  ModificarFotoSoporte(FotoNueva, FotoVieja, IdSoporte) {
    let form: FormData = new FormData();
    form.append("Archivo", FotoNueva, FotoNueva.name);
    form.append("FotoVieja", FotoVieja);
    form.append("IdSoporte", IdSoporte);
    return this.http.post(`${this.baseUrl}/ModificarFotoSoporte`, form);
  }

  EliminarFotoSoporte(FotoVieja, IdSoporte) {
    return this.http.post(`${this.baseUrl}/EliminarFotoSoporte`, {
      FotoVieja,
      IdSoporte,
    });
  }

  /**
   * Sube imagen de soporte
   * @param supportImage imagen a subir 
   * @returns Observable
   */
  SubirFotoSoporte(supportImage: File): Observable<any> {
    let form: FormData = new FormData();
    form.append("Archivo", supportImage, supportImage.name);
    return this.http.post(`${this.baseUrl}/SubirFotoSoporte`, form);
  }

  /**
   * Traer listado de camaras
   * @param Soporte id de soporte
   * @param IdMunicipio id de municipio 
   * @param Valor valor a buscar
   * @param Activa bandera que representa si desea buscar por elementos activos o no 
   * @param Idioma idioma
   * @param pageIndex indice de la pagina actual 
   * @param pageSize numero de resultados a obtener en la busqueda
   * @returns Observable
   */
  TraerCamarasGenerales(
    Soporte: any,
    IdMunicipio: number,
    Valor: string,
    Activa: boolean,
    Idioma: string,
    pageIndex: number,
    pageSize: number,
    sort: { active: string, direction: '' | 'asc' | 'desc' }
  ): Observable<CamaraG[]> {
    const data = {
      Soporte: Soporte,
      IdMunicipio: IdMunicipio,
      Valor: Valor,
      Activa: Activa,
      Idioma: Idioma,
      pageIndex,
      pageSize,
      sort
    };
    return this.http.post<CamaraG[]>(`${this.baseUrl}/InfoCamaras`, data);
  }

  TraerSoporte(activado, IdMunicipio) {
    const data = {
      activado: activado,
      IdMunicipio: IdMunicipio,
    };
    return this.http.post(`${this.baseUrl}/TraerSoporte`, data);
  }

  GuardarCamara(
    id_camara,
    IdSoporte,
    Altura,
    GradosOrientacion,
    Ip,
    marca,
    modelo,
    posicion,
    nombre,
    IdTipoCamara,
    alcanceCoordenadas?,
    parking?,
    ahorro_consumo?: number,
    peatones_lineas?: boolean,
    timelapse?: boolean,
    conteo_bicis?: boolean,
    id_subtipo?: number
  ) {
    const data = {
      id_camara: id_camara,
      IdSoporte: IdSoporte,
      Altura: Altura,
      GradosOrientacion: GradosOrientacion,
      Ip: Ip,
      modelo: modelo,
      marca: marca,
      posicion: posicion,
      nombre: nombre,
      IdTipoCamara: IdTipoCamara,
      alcanceCoordenadas: alcanceCoordenadas,
      parking: parking,
      ahorro_consumo: ahorro_consumo,
      peatones_lineas: peatones_lineas,
      timelapse: timelapse,
      conteo_bicis: conteo_bicis,
      id_subtipo
    };
    return this.http.post(`${this.baseUrl}/GuardarCamara`, data);
  }

  ModificarCamara(
    Id,
    id_camara,
    IdSoporte,
    Altura,
    GradosOrientacion,
    Ip,
    marca,
    modelo,
    posicion,
    nombre,
    IdTipoCamara,
    tipoDeteccion,
    Activa,
    alcanceCoordenadas,
    parking,
    ahorro_consumo: number,
    peatones_lineas: boolean,
    timelapse?: boolean,
    conteo_bicis?: boolean,
    id_subtipo?: number
  ) {
    const data = {
      Id: Id,
      id_camara: id_camara,
      IdSoporte: IdSoporte,
      Altura: Altura,
      GradosOrientacion: GradosOrientacion,
      Ip: Ip,
      modelo: modelo,
      marca: marca,
      posicion: posicion,
      nombre: nombre,
      IdTipoCamara: IdTipoCamara,
      tipoDeteccion: tipoDeteccion,
      Activa: Activa,
      alcanceCoordenadas: alcanceCoordenadas,
      parking: parking,
      ahorro_consumo: ahorro_consumo,
      peatones_lineas: peatones_lineas,
      timelapse: timelapse,
      conteo_bicis: conteo_bicis,
      id_subtipo
    };
    return this.http.post(`${this.baseUrl}/ModificarCamara`, data);
  }

  ValidarPosicion(IdSoporte, posicion) {
    const data = {
      IdSoporte: IdSoporte,
      posicion: posicion,
    };
    return this.http.post(`${this.baseUrl}/ValidarPosicion`, data);
  }

  ultimaImagenCamara(idCamara, municipio) {
    const data = {
      IdCamara: idCamara,
      municipio,
    };
    return this.http.post(`${this.baseUrl}/TraerUltimaImagenProcesada`, data);
  }

  listadoImagenes(idCamara, cantidad) {
    const data = {
      IdCamara: idCamara,
      Cantidad: cantidad,
    };
    return this.http.post(`${this.baseUrl}/ListadoImagenes`, data);
  }

  listadoImagenesFiltrado(data) {
    return this.http.post(`${this.baseUrl}/ListadoImagenesFiltrado`, data);
  }

  TraerDetalleSoporte(IdSoporte, IdMunicipio) {
    const data = {
      IdSoporte: IdSoporte,
      IdMunicipio: IdMunicipio,
    };
    return this.http.post(`${this.baseUrl}/DetalleSoporte`, data);
  }

  TraerImagen(Archivo) {
    const data = {
      Archivo: Archivo,
    };
    return this.http.post(`${this.UrlserviciosImg}/UltimaProcesada`, data);
  }

  soporteMapa(idMunicipio) {
    const data = {
      idMunicipio: idMunicipio,
    };
    return this.http.post(`${this.baseUrl}/Soportes`, data);
  }

  TraerCallesPorMunicipio(cantidad, IdMunicipio) {
    const data = {
      Cantidad: cantidad,
      IdMunicipio: IdMunicipio,
    };
    return this.http.post(`${this.baseUrl}/TraerCallesPorMunicipio`, data);
  }

  AlmacenarCalle(Nombre, IdMunicipio) {
    const data = { Nombre, IdMunicipio };
    return this.http.post(`${this.baseUrl}/AlmacenarCalle`, data);
  }

  ModificarCalle(IdCalle, Nombre, IdMunicipio, Eliminado) {
    const data = {
      IdCalle: IdCalle,
      Nombre: Nombre,
      IdMunicipio: IdMunicipio,
      Eliminado: Eliminado,
    };
    return this.http.post(`${this.baseUrl}/ModificarCalle`, data);
  }

  /**
   * Traer calles de un municipio
   * @param Nombre nombre de la calle
   * @param IdMunicipio id del municipio
   * @param pageIndex Index actual de la paginacion
   * @param pageSize cantidad de registro por paginas
   * @returns observable
   */
  TraerCallesMunicipio(Nombre: string, IdMunicipio: string | number, Activa: boolean, pageIndex: number, pageSize: number, sort): Observable<calleG[]> {
    const data = {
      Nombre: Nombre,
      IdMunicipio: IdMunicipio,
      pageIndex,
      pageSize,
      Activa,
      sort
    };
    return this.http.post<{ totalRegistros: number, data: calleG[] }>(`${this.baseUrl}/TraerCallesMunicipio`, data)
      // TODO: Se agrega transformacion temporal para probar el query utilizando sequelize
      .pipe(map((response: { totalRegistros: number, data: calleG[] }) => {
        return response.data.map((street) => ({
          ...street,
          totalRegistros: response.totalRegistros
        }));
      }));
  }

  getListCameras(IdMunicipio, OcultarMatricula) {
    return this.http.post(`${this.baseUrl}/ListCamara`, {
      IdMunicipio,
      OcultarMatricula,
    });
  }

  actualizarConfiguracion(Configuracion) {
    return this.http.post(
      `${this.baseUrl}/ActualizarConfiguracion`,
      Configuracion
    );
  }

  TraerCamara(idCamara, municipio) {
    const data = {
      IdCamara: idCamara,
      municipio,
    };
    return this.http.post(`${this.baseUrl}/TraerUltimaImagenProcesada`, data);
  }

  TraerTiposCamara(cantidad, valor, activo) {
    const data = {
      Cantidad: cantidad,
      Valor: valor,
      activo: activo
    };
    return this.http.post(`${this.baseUrl}/TraerTiposCamara`, data);
  }

  AlmacenarTipoCamara(TipoCamara, Descripcion, Peatones) {
    const data = {
      TipoCamara: TipoCamara,
      Descripcion: Descripcion,
      Peatones: Peatones,
    };
    return this.http.post(`${this.baseUrl}/AgregarTipoCamara`, data);
  }

  ModificarTipoCamara(IdTipoCamara, TipoCamara, Descripcion, Activo, Peatones) {
    const data = {
      IdTipoCamara: IdTipoCamara,
      TipoCamara: TipoCamara,
      Descripcion: Descripcion,
      Activo: Activo,
      Peatones: Peatones,
    };
    return this.http.post(`${this.baseUrl}/ModificarTipoCamara`, data);
  }

  /**
   * Obtener routers
   * @param valor valor a comparar
   * @param IdMunicipio id de municipio
   * @param activo bandera
   * @param clima bandera
   * @param pageIndex indice de la pagina actual
   * @param pageSize cantidad de registros a obetener
   * @returns Observable
   */
  TraerRouters(
    valor: string,
    IdMunicipio: string | number,
    activo: any,
    clima = false,
    pageIndex: number = null,
    pageSize: number = null,
    sort = { active: 'idRouter', direction: '' },
    idSoporte = null
  ) {
    const data = {
      Valor: valor,
      IdMunicipio: IdMunicipio,
      activo,
      clima,
      pageIndex,
      pageSize,
      sort,
      idSoporte
    };

    return this.http.post(`${this.baseUrl}/TraerRouters`, data);
  }
  TraerTipoGuardian() {
    return this.http.post(`${this.baseUrl}/TraerTipoGuardian`, {});
  }
  TraerTelemetriaRouters(Idrouter, IdMunicipio, FechaI, FechaF) {
    const data = {
      Idrouter: Idrouter,
      IdMunicipio: IdMunicipio,
      FechaI: FechaI,
      FechaF: FechaF,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    };

    return this.http.post(`${this.baseUrl}/TraerTelemetriaRouters`, data);
  }

  TraerTelemetriaAlimentacion(Idrouter, IdMunicipio, FechaI, FechaF) {
    const data = {
      Idrouter: Idrouter,
      IdMunicipio: IdMunicipio,
      FechaI: FechaI,
      FechaF: FechaF,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    };

    return this.http.post(`${this.baseUrl}/TraerTelemetriaAlimentacion`, data);
  }

  TraerTelemetriaAlarmas(Idrouter, IdMunicipio, FechaI, FechaF) {
    const data = {
      Idrouter: Idrouter,
      IdMunicipio: IdMunicipio,
      FechaI: FechaI,
      FechaF: FechaF,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    };

    return this.http.post(`${this.baseUrl}/TraerTelemetriaAlarmas`, data);
  }

  AlmacenarRouter(
    SSID,
    Ip,
    IdSoporte,
    CDI,
    Telefono,
    IdTipoGuardian,
    poste,
    SerieRouter,
    MacRouter,
    Imei,
    IpRed,
    Ndispositivos,
    tracking,
    tiene_clima
  ) {
    const data = {
      SSID: SSID,
      Ip: Ip,
      IdSoporte: IdSoporte,
      CDI: CDI,
      Telefono: Telefono,
      IdTipoGuardian,
      poste,
      SerieRouter: SerieRouter,
      MacRouter: MacRouter,
      Imei: Imei,
      IpRed: IpRed,
      Ndispositivos: Ndispositivos,
      tracking: tracking,
      tiene_clima: tiene_clima
    };
    return this.http.post(`${this.baseUrl}/AgregarRouter`, data);
  }

  ModificarRouter(
    IdRouter,
    SSID,
    Ip,
    IdSoporte,
    CDI,
    Telefono,
    IdTipoGuardian,
    poste,
    SerieRouter,
    MacRouter,
    Imei,
    IpRed,
    Ndispositivos,
    Activo,
    tracking,
    tiene_clima
  ) {
    const data = {
      IdRouter: IdRouter,
      SSID: SSID,
      Ip: Ip,
      IdSoporte: IdSoporte,
      CDI: CDI,
      Telefono: Telefono,
      IdTipoGuardian: IdTipoGuardian,
      poste,
      SerieRouter: SerieRouter,
      MacRouter: MacRouter,
      Imei: Imei,
      IpRed: IpRed,
      Ndispositivos: Ndispositivos,
      Activo: Activo,
      tracking: tracking,
      tiene_clima: tiene_clima
    };

    return this.http.post(`${this.baseUrl}/ModificarRouter`, data);
  }

  listFile(dates: any) {
    return this.http.post(`${this.baseUrl}/ListarArchivosCamara`, dates);
  }

  store(endpoint, object): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/StreamFallbackCanal2`,
      { ...object, endpoint },
    );
  }

  /**
   * Reproduce stream
   * @param id_camara ip
   * @param channel canal 
   * @returns Observable
   */
  streamCameras2(id_camara: string, channel: number) {
    return this.store('stream2', { id_camara, channel });
  }

  /**
   * Detiene el stream de datos
   * @param id_camara ip
   * @returns Observable
   */
  videoStreamStop(id_camara: string) {
    return this.store(
      "stream/stop",
      { id_camara },
    );
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */

  /**
   * Obtener estado camara PTZ
   * @param ip ip
   * @param user user cifrado
   * @param pass pass cifrado
   * @returns Observable
   */
  obtenerEstadoPTZ(ip: string, user: string, pass: string) {
    return of();
  }

  /**
   * Envia comando countinuo camara PTZ
   * @param ip ip   
   * @param user usuario cifrado
   * @param pass pass cifrado
   * @param position position
   * @returns Observable
   */
  enviarComandoContinous(ip: string, user: string, pass: string, position: any) {
    return of();
  }

  /**
    * Envia comando absoluto camara PTZ
    * @param ip ip   
    * @param user usuario cifrado
    * @param pass pass cifrado
    * @param position position
    * @returns Observable
    */
  enviarComandoAbsolute(ip: string, user: string, pass: string, position: any) {
    return of();
  }

  presetPTZ(ip, user, pass, method: 'SAVE' | 'CALL' | 'DELETE', presetId?: number) {
    return of();
  }

  focusPTZ(ip, user, pass, focus) {
    return of();
  }

  irisPTZ(ip, user, pass, iris) {
    return of();
  }

  /* eslint-enable @typescript-eslint/no-unused-vars */

  videoStreamRecord(data) {
    return this.http.post(`${this.UrlserviciosStream}/api/stream/record`, data);
  }

  TraerCamara2(IdCamaras: any[], fecha: string, tiempo: number, idmunicipio: number) {
    const data = {
      zonaHoraria: this.fsession.optenerValor("dato41"),
      IdCamaras: IdCamaras,
      Fecha: fecha,
      Tiempo: tiempo,
      idMunicipio: idmunicipio,
    };

    return this.http.post(`${this.baseUrl}/TraerImagenProcesadaPorFecha`, data);
  }

  Validarserierepetida(id_camara) {
    const data = {
      id_camara: id_camara,
    };
    return this.http.post(`${this.baseUrl}/Validarserierepetida`, data);
  }

  TraerUltimgCamara(IdCamaras) {
    const data = {
      IdCamaras: IdCamaras,
    };

    return this.http.post(`${this.baseUrl}/TraerUltimgCamaras`, data);
  }

  /**
   * Descarga de videos pendientes
   * @param data datos necesarios para la descarga
   * @param viewDownloads tipo de vista para la descarga, puede ser "individual" o "multiple"
   * @returns Observable
   */
  descargasPendientes(data: any, viewDownloads: 'individual' | 'multiple' | 'archivado'): Observable<{ Descargas: any[], mensaje: string }> {
    return this.http.post<{ Descargas: any[], mensaje: string }>(`${this.baseUrl}/DescargasPendientes`, { data, viewDownloads });
  }

  traerUrlVideo(data) {
    return this.http.post(`${this.baseUrl}/traerUrlVideo`, data);
  }

  downloadFileBackground(data) {
    let Fechalimite = new Date();
    Fechalimite.setDate(Fechalimite.getDate() + 7);
    return this.http.post(`${this.baseUrl}/AgregarDescargaPendiente`, {
      data,
      Fechalimite,
    });
  }

  obtenerLimiteDescarga(idUsuario, fechaActual) {
    return this.http.post(
      `${this.baseUrl}/obtenerCantidadDescargasPendientes`,
      { idUsuario, fechaActual }
    );
  }

  obtenerUsuario() {
    let t = this.fsession.optenerValor("dato1");
    const h = new JwtHelperService();
    const dT = h.decodeToken(t);
    return dT.fviu;
  }

  ModificarMatricula(data) {
    return this.http.post(`${this.baseUrl}/ModificarMatricula`, data);
  }

  mapaTrafico(data) {
    return this.http.post(`${this.baseUrl}/mapaTrafico`, data);
  }

  traerUltImagenes(cantidad, Municipio) {
    return this.http.post(`${this.baseUrl}/TraerUltImagenes`, {
      cantidad,
      Municipio,
    });
  }

  /**
   * Obtiene las ultimas imagenes de las camaras seleccionadas
   * @param cantidad numero de grid
   * @param Municipio id de municipio
   * @param ArrayCamaras arreglo de ids de las camaras seleccionadas
   * @returns Observable
   */
  traerUltImagenesNuevoVisor(cantidad: number, Municipio: string, ArrayCamaras: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/TraerUltImagenesNuevoVisor`, {
      cantidad,
      Municipio,
      ArrayCamaras,
    });
  }


  /**
   * Traer informacion de matriculas
   * @param municipio Municipio
   * @param FechaI Fecha de inicio de las detecciones
   * @param FechaF Fecha de fin de las detecciones
   * @param CamSel Cámaras de detecciones
   * @param idioma Idioma a mostrar
   * @returns
   */
  TraerInfPersonasBD(
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    prefilters?: any,
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      prefiltros: prefilters
    };
    return this.http.post<any>(`${this.baseUrl}/TraerPersonasBd`, data);
  }

  /**
   * Traer informacion de matriculas
   * @param matricula filtro por matricula del vehiculo
   * @param municipio Municipio
   * @param FechaI Fecha de inicio de las detecciones
   * @param FechaF Fecha de fin de las detecciones
   * @param CamSel Cámaras de detecciones
   * @param idioma Idioma a mostrar
   * @param soloPendientes Si se muestran solo las infracciones
   * @param color filtro por color
   * @param TipoDeteccion Filtro por deteccion
   * @param marca filtro por marca del vehiculo
   * @param velocidadInicial filtro de por velocidad del vehiculo
   * @param velocidadFinal filtro de por velocidad del vehiculo
   * @returns
   */
  TraerMatriculasVerificacionPol(
    matricula: string,
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    soloPendientes: boolean,
    color: string,
    TipoDeteccion: string,
    marca: string,
    velocidadInicial: number,
    velocidadFinal: number,
    noplate: boolean,
    listVehicleInterests: string
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      matricula,
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      soloPendientes,
      color: color,
      TipoDeteccion: TipoDeteccion,
      marca: marca,
      velocidadInicial: velocidadInicial,
      velocidadFinal: velocidadFinal,
      noplate: noplate,
      listVehicleInterests: listVehicleInterests
    };
    return this.http.post<any>(`${this.baseUrl}/TraerMatriculasVerificacion`, data);
  }

  /**
   * Traer informacion de matriculas
   * @param matricula filtro por matricula del vehiculo
   * @param municipio Municipio
   * @param FechaI Fecha de inicio de las detecciones
   * @param FechaF Fecha de fin de las detecciones
   * @param CamSel Cámaras de detecciones
   * @param idioma Idioma a mostrar
   * @param soloFotoRojo Si se muestran solo las infracciones
   * @param color filtro por color
   * @param TipoDeteccion Filtro por deteccion
   * @param marca filtro por marca del vehiculo
   * @param velocidadInicial filtro de por velocidad del vehiculo
   * @param velocidadFinal filtro de por velocidad del vehiculo
   * @returns
   */
  TraerInfMatriculasBD(
    matricula: string,
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    soloFotoRojo: boolean,
    color: string,
    TipoDeteccion: string,
    marca: string,
    velocidadInicial: number,
    velocidadFinal: number,
    noplate: boolean,
    listVehicleInterests: string
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      matricula,
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      soloFotoRojo: soloFotoRojo,
      color: color,
      TipoDeteccion: TipoDeteccion,
      marca: marca,
      velocidadInicial: velocidadInicial,
      velocidadFinal: velocidadFinal,
      noplate: noplate,
      listVehicleInterests: listVehicleInterests
    };
    return this.http.post<any>(`${this.baseUrl}/TraerMatriculasBd2`, data);
  }

  /**
   * Traer matriculas multas e infracciones CGI
   * @param matricula filtro por matricula del vehiculo
   * @param municipio Municipio
   * @param FechaI Fecha de inicio de las detecciones
   * @param FechaF Fecha de fin de las detecciones
   * @param CamSel Cámaras de detecciones
   * @param idioma Idioma a mostrar
   * @param soloFotoRojo Si se muestran solo las infracciones
   * @param color filtro por color
   * @param TipoDeteccion Filtro por deteccion
   * @param marca filtro por marca del vehiculo
   * @param velocidadInicial filtro de por velocidad del vehiculo
   * @param velocidadFinal filtro de por velocidad del vehiculo
   * @returns
   */
  TraerMatriculasDb2_multas_infracciones(
    matricula: string,
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    soloFotoRojo: boolean,
    color: string,
    TipoDeteccion: string,
    marca: string,
    velocidadInicial: number,
    velocidadFinal: number,
    noplate: boolean,
    listVehicleInterests: string
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      matricula,
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      soloFotoRojo: soloFotoRojo,
      color: color,
      TipoDeteccion: TipoDeteccion,
      marca: marca,
      velocidadInicial: velocidadInicial,
      velocidadFinal: velocidadFinal,
      noplate: noplate,
      listVehicleInterests: listVehicleInterests
    };
    return this.http.post<any>(`${this.baseUrl}/TraerMatriculasDb2_multas_infracciones`, data);
  }

  TraerInfMatriculasBD_IA7(
    matricula: string,
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    soloFotoRojo: boolean,
    color: string,
    TipoDeteccion: string,
    marca: string,
    velocidadInicial: number,
    velocidadFinal: number,
    noplate: boolean,
    listVehicleInterests: string
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      matricula,
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      soloFotoRojo: soloFotoRojo,
      color: color,
      TipoDeteccion: TipoDeteccion,
      marca: marca,
      velocidadInicial: velocidadInicial,
      velocidadFinal: velocidadFinal,
      noplate: noplate,
      listVehicleInterests: listVehicleInterests
    };
    return this.http.post<any>(`${this.baseUrl}/TraerMatriculasBd2_IA7`, data);
  }

  TraerImageneseventoscam(Idseventoscam) {
    const data = {
      Idseventoscam: Idseventoscam,
    };
    return this.http.post(`${this.baseUrl}/TraerImageneseventoscam`, data);
  }

  obtenerUrlAvanzadaInfraccion(archivo, sin_OCR, tipoInfraccion, confirmada, deteccionPrincipal = false, incluirDeteccionPeatones = false,):
    Observable<{ fotosArray: { url: string, numero: number, blobName: string }[], videoUrl: string, ocrFileUrl: string, videoPeatones1?: string, videoPeatones2?: string }> {
    const data = {
      archivo,
      sin_OCR,
      tipoInfraccion,
      confirmada,
      deteccionPrincipal,
      incluirDeteccionPeatones,
    };
    return this.http.post<{ fotosArray: { url: string, numero: number, blobName: string }[], videoUrl: string, jsonFileUrl: string, ocrFileUrl: string, videoPeatones1?: string, videoPeatones2?: string }>(`${this.baseUrl}/obtenerUrlAvanzadaInfraccion`, data);
  }

  /**
   * Agregar descarga pendiente de evento
   * @param FechaEventoInicio fecha inicio del evento
   * @param FechaEventoFin fecha final del evento
   * @param FechaEventoInicioUtc fecha inicio del evento en UTC
   * @param FechaEventoFinUtc fecha final del evento en UTC
   * @param Municipio id de municipio
   * @param Camara id de la camara selecionada del evento
   * @param playbackURI playbackURI
   * @param nombre nombre de la camara
   * @param duracion duracion del evento
   * @param Fechalimite fecha limite del evento
   * @returns Observable
   */
  DescargaPendienteEvento(
    FechaEventoInicio: string,
    FechaEventoFin: string,
    FechaEventoInicioUtc: string,
    FechaEventoFinUtc: string,
    Municipio: string | number,
    Camara: string,
    playbackURI: string,
    nombre: string,
    duracion: number,
    Fechalimite: any
  ) {

    var data = {
      FechaEventoInicio,
      FechaEventoFin,
      FechaEventoInicioUtc,
      FechaEventoFinUtc,
      Municipio,
      Camara,
      playbackURI,
      nombre,
      duracion,
      Fechalimite,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    };

    return this.http.post(
      `${this.baseUrl}/AgregarDescargaPendienteEvento`,
      data
    );
  }

  /**
   * Actualiza el estado de una descarga pendiente.
   * @param IdPendiente id de la descarga pendiente
   * @param isMultiDownload indica si es una descarga multiple (es decir varias camaras)
   * @returns Observable con el resultado
   */
  ActualizarEstadoPendienteDesc(IdPendiente: number | string, isMultiDownload: boolean) {
    var data = {
      IdPendiente,
      isMultiDownload
    };
    return this.http.post(
      `${this.baseUrl}/ActualizarEstadoPendienteDesc`,
      data
    );
  }

  TraerCamaraMatricula(municipio: string | number | number[] | string[]): Observable<any> {
    var data = {
      municipio,
    };
    return this.http.post(`${this.baseUrl}/TraerCamarasMatriculas`, data);
  }

  TraerConfigUsuario() {
    var data = null;
    return this.http.post(`${this.baseUrl}/TraerConfigUsuario`, data);
  }

  BuquedaAvanzada(Fecha, intervalo, id_camara, futuro) {
    var data = {
      Fecha,
      intervalo,
      id_camara,
      futuro,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    };
    return this.http.post(`${this.baseUrl}/BuquedaAvanzada`, data);
  }

  TraerAlerta() {
    return this.http.post(`${this.baseUrl}/Alerta`, null);
  }

  /**
   * Traer listado de alertas
   * @param origin Origen de la alerta
   * @param estado Estado de la alerta
   * @param clave Clave de la alerta
   * @param Idioma Idioma a buscar
   * @param pageIndex Indice de la pagina actual
   * @param pageSize Numero de resultados a obtener en la busqueda
   * @param sort Ordenamiento de los resultados
   * @returns Observable
   */
  AlertaBusqueda(origin: number, estado: number, clave: any, Idioma: any, pageIndex: number, pageSize: number, sort: Sort) {
    return this.http.post(`${this.baseUrl}/AlertaBusqueda`, {
      origin,
      estado,
      clave,
      Idioma,
      pageIndex,
      pageSize,
      sort
    });
  }

  AlertaBusqueda2(origin, estado, clave, Idioma, IdMunicipio) {
    return this.http.post(`${this.baseUrl}/AlertaBusqueda2`, {
      origin,
      estado,
      clave,
      Idioma,
      IdMunicipio,
    });
  }

  ActualizarAlerta(Fecha, IdAlerta, estado) {
    return this.http.post(`${this.baseUrl}/ActualizarAlerta`, {
      Fecha,
      IdAlerta,
      estado,
    });
  }

  traerUltimaImgArray(cant, idMun) {
    return this.http.post(`${this.baseUrl}/traerUltimaImgArray`, {
      cant,
      idMun,
    });
  }

  /**
    * Obtener listado de cámaras con filtros avanzados
   * @param Nombre Nombre de una cámara en específico
   * @param TipoCamara Tipo de cámaras a mostrar.
   * @param Soporte Id del soporte, una cadena con múltiples IDs separados por comas, o un array de IDs
   * @param IdMunicipio  Id del municipio (número), cadena "1,2,3", o array de números (municipio virtual: ids reales, no 329)
   * @param OcultarMatricula Indica si se deben ocultar las cámaras de tipo matrícula
   * @param Activa Indica si se deben incluir solo cámaras activas
   * @param m Indica si debe filtrar por cámaras que no sean de tipo matrícula
   * @param filter  Filtros adicionales
   * @param timelapse  Indica si se deben incluir cámaras de timelapse
   * @returns Observable con el listado de cámaras que cumplen con los filtros aplicados
   */
  getListCameras2(
    Nombre,
    TipoCamara,
    Soporte,
    IdMunicipio: number | string | number[],
    OcultarMatricula,
    Activa,
    m,
    filter,
    timelapse: boolean = false
  ) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/ListCamara2`, {
      Nombre,
      TipoCamara,
      Soporte,
      IdMunicipio,
      OcultarMatricula,
      Activa,
      m,
      idioma,
      filter,
      timelapse
    });
  }

  traerAuditoria(Suceso, Fecha1, Fecha2, Usuario) {
    return this.http.post(`${this.baseUrl}/auditoriaUsuario`, {
      Suceso,
      Fecha1,
      Fecha2,
      Usuario,
    });
  }

  traerUsuariosAuditoria() {
    return this.http.post(`${this.baseUrl}/traerUsuariosAuditoria`, null);
  }

  obtenerIp() {
    return this.http.get(this.serverIpPublica);
  }

  public asignarIpPublica() {
    this.obtenerIp().subscribe((res: any) => {
      this.IpPublica = res.ip;
      this.fsession.agregarActualizar("user-ip", this.IpPublica);
    });
  }

  getBrowserInfo = function () {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  };

  traerBuzon(filtro) {
    return this.http.post(`${this.baseUrl}/Buzon`, { filtro });
  }

  traerModemBuzon() {
    return this.http.post(`${this.baseUrl}/BuzonModems`, null);
  }

  crearBuzon(IdModem, Mensaje, Fecha) {
    return this.http.post(`${this.baseUrl}/crearBuzon`, {
      IdModem,
      Mensaje,
      Fecha,
    });
  }

  /**
   * Modifica el estado del una descarga pendiente
   * @param {any} IdPendiente Identificador del pendiente de descarga
   * @param {number} opcion Opcion
   * @param {boolean} isMultiDownload Indica si la descarga es de tipo 'multidescarga'
   * @returns {Observable<any>} Observable con la respuesta del servidor
   */
  EliminarPendienteDesc(IdPendiente: any, opcion: UpdateOptionsDownload, isMultiDownload: boolean): Observable<any> {
    let Fechalimite = new Date();
    var data = {
      IdPendiente,
      Fechalimite,
      opcion,
      isMultiDownload
    };
    return this.http.post(`${this.baseUrl}/EliminarPendienteDesc`, data);
  }

  DetallesAlerta(idAlerta) {
    return this.http.post(`${this.baseUrl}/DetallesAlerta`, { idAlerta });
  }

  InsertarDetallesAlerta(idAlerta, idUsuario, comentario, fecha) {
    return this.http.post(`${this.baseUrl}/GuardarDetallesAlerta`, {
      idAlerta,
      idUsuario,
      comentario,
      fecha,
    });
  }

  GuardarParametrosGenerales(CantCamaras = null, CantDescargas = null, ManualUsuario = null, ValoresDegradadoMapa = null) {
    return this.http.post(`${this.baseUrl}/GuardarParametrosGenerales`, {
      CantCamaras,
      CantDescargas,
      ManualUsuario,
      ValoresDegradadoMapa
    });
  }


  GuardarParametrosMunicipio(ValoresDegradadoMapa, idMunicipio) {
    return this.http.post(`${this.baseUrl}/GuardarParametrosMunicipio`, {
      idMunicipio,
      ValoresDegradadoMapa,
    });
  }


  TraerParametrosMunicipio(idMunicipio) {
    return this.http.post(`${this.baseUrl}/TraerParametrosMunicipio`, {
      idMunicipio
    });
  }

  traerInfoVelocidad(
    soporte1,
    soporte2,
    fechaI,
    fechaF,
    page,
    cantidad,
    infractor
  ) {
    return this.http.post(`${this.baseUrl}/TraerInfoVelocidad`, {
      soporte1,
      soporte2,
      fechaI,
      fechaF,
      page,
      cantidad,
      infractor,
    });
  }

  traerInfoCantidadVelocidad(soporte1, soporte2, fechaI, fechaF, matriculas) {
    return this.http.post(`${this.baseUrl}/traerInfoCantidadVelocidad`, {
      soporte1,
      soporte2,
      fechaI,
      fechaF,
      matriculas,
    });
  }

  traerInfoVelocidadTotalDatos(soporte1, soporte2, fechaI, fechaF) {
    return this.http.post(`${this.baseUrl}/TraerInfoVelocidadTotalDatos`, {
      soporte1,
      soporte2,
      fechaI,
      fechaF,
    });
  }
  traerInfoVelocidadMunicipiosHabilitados(id) {
    return this.http.post(
      `${this.baseUrl}/TraerInfoVelocidadMunicipiosHabilitados`,
      { id }
    );
  }


  soporteMapa3(idMunicipio) {
    const data = {
      idMunicipio: idMunicipio,
    };
    return this.http.post(`${this.baseUrl}/Soportes3`, data);
  }

  traerIdCamarasMunicipio(idMunicipio) {
    return this.http.post(`${this.baseUrl}/TraerIdCamarasMunicipio`, {
      idMunicipio,
    });
  }
  TraerGraficoMatricula(camaras, tipo, fecha, titulo) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/TraerGraficoMatricula`, {
      camaras,
      tipo,
      fecha,
      idioma,
      titulo,
    });
  }
  TraerGraficoMatricula2(camaras, tipo, fecha, titulo) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/TraerGraficoMatricula2`, {
      camaras,
      tipo,
      fecha,
      idioma,
      titulo,
    });
  }
  TraerGraficoVehiculos(camaras, tipo, fecha, titulo) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/TraerGraficoVehiculos`, {
      camaras,
      tipo,
      fecha,
      idioma,
      titulo,
    });
  }
  TraerGraficoVehiculosV2(camaras, tipo, fecha, titulo) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/TraerGraficoVehiculosV2`, {
      camaras,
      tipo,
      fecha,
      idioma,
      titulo,
    });
  }
  TraerGraficoVH(camaras, tipo, fecha, titulo) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/TraerGraficoVH`, {
      camaras,
      tipo,
      fecha,
      idioma,
      titulo,
    });
  }
  TraerTopMatricula(camaras, tipo, fecha) {
    return this.http.post(`${this.baseUrl}/TraerTopMatriculas`, {
      camaras,
      tipo,
      fecha,
    });
  }
  TraerResumenMatricula(camaras, tipo, fecha) {
    return this.http.post(`${this.baseUrl}/TraerResumenMatricula`, {
      camaras,
      tipo,
      fecha,
    });
  }
  traerInfoVelocidadTramos(municipio) {
    return this.http.post(`${this.baseUrl}/TraerInfoVelocidadTramos`, {
      municipio,
    });
  }

  traerInfoVelocidadEventosMatricula(
    soporte1,
    soporte2,
    fechaI,
    fechaF,
    matricula
  ) {
    return this.http.post(
      `${this.baseUrl}/TraerInfoVelocidadEventosMatricula`,
      { soporte1, soporte2, fechaI, fechaF, matricula }
    );
  }

  TraerGraficoEfectividad(FechaI, FechaF, Municipio, Tipo) {
    return this.http.post(`${this.baseUrl}/TraerGraficoReporteCamaras`, {
      FechaI,
      FechaF,
      Municipio,
      Tipo,
    });
  }

  traerSoportesMunicipio(municipio) {
    return this.http.post(`${this.baseUrl}/TraerSoportesMunicipio`, {
      municipio,
    });
  }

  guardarTramo(data: any) {
    return this.http.post(`${this.baseUrl}/GuardarTramo`, data);
  }

  /**
   * Traer detalle de matricula
   * @param matricula matricula del vehiculo
   * @param camaras camaras
   * @param fecha fecha
   * @param tipo tipo
   * @returns Observable
   */
  DetalleMatricula(matricula: string, camaras: string, fecha: string, tipo: number): Observable<LicensePlateDetails[]> {
    return this.http.post<any>(`${this.baseUrl}/DetalleMatricula`, {
      matricula,
      camaras,
      fecha,
      tipo,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  traerInfoGeneralAuditoria(fechaI, fechaF, nombreUsuario, endpoint) {
    return this.http.post(`${this.baseUrl}/TraerInfoGeneralAuditoria`, {
      fechaI,
      fechaF,
      nombreUsuario,
      endpoint,
    });
  }

  traerInfoAuditoriaMunicipio(fechaI, fechaF, nombreUsuario, endpoint) {
    return this.http.post(`${this.baseUrl}/TraerAuditoriaMunicipio`, {
      fechaI,
      fechaF,
      nombreUsuario,
      endpoint,
    });
  }

  traerInfoGeneralNuevaAuditoriaAdministrador_V1(fechaI, fechaF, nombreUsuario, endpoint) {
    return this.http.post(`${this.baseUrl}/traerInfoGeneralNuevaAuditoriaAdministrador_V1`, {
      fechaI,
      fechaF,
      nombreUsuario,
      endpoint,
    });
  }

  traerInfoAuditoriaUsuario(usuario, fechaI, fechaF, idMunicipio) {
    return this.http.post(`${this.baseUrl}/TraerInfoAuditoriaUsuario`, {
      usuario,
      fechaI,
      fechaF,
      idMunicipio,
    });
  }
  ObtenerMatriculas(camaras, tipo, fecha, offset, pageSize, calculateCount) {
    return this.http.post(`${this.baseUrl}/ObtenerMatriculas`, {
      camaras,
      tipo,
      fecha,
      offset,
      pageSize,
      calculateCount,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  TraerImagenSoporte(Archivo) {
    const data = {
      Archivo: Archivo,
    };
    return this.http.post(`${this.baseUrl}/TraerImagenSoporte`, data);
  }

  TraerGraficoVehiculosTramo(tramo, tipo, fecha, titulo) {
    var idioma = this.fsession._currentLang.value;

    return this.http.post(`${this.baseUrl}/TraerGraficoVehiculosTramo`, {
      tramo,
      tipo,
      fecha,
      idioma,
      titulo,
    });
  }
  TraerGraficoVehiculosTramoV2(tramo, tipo, fecha, titulo) {
    var idioma = this.fsession._currentLang.value;

    return this.http.post(`${this.baseUrl}/TraerGraficoVehiculosTramoV2`, {
      tramo,
      tipo,
      fecha,
      idioma,
      titulo,
    });
  }
  ObtenerMatriculasTramo(tramo, tipo, fecha) {
    return this.http.post(`${this.baseUrl}/ObtenerMatriculasTramo`, {
      tramo,
      tipo,
      fecha,
    });
  }
  TraerDetMatriculaTramo(Fecha, CategoriaConsulta, Tramo, Matricula) {
    return this.http.post(`${this.baseUrl}/TraerDetMatriculaTramo`, {
      Fecha,
      CategoriaConsulta,
      Tramo,
      Matricula,
    });
  }

  /**
   * Traer informacion velocidad tramos 2
   * @param municipio id de muncipio
   * @param activo boolean
   * @param todos numero puede ser 0 || 1
   * @param filter filtro para realizar la busqueda por la descripcion del tramo
   * @param pageIndex indice actual de la paginacion
   * @param pageSize cantidad de registro por paginas
   * @returns Observable
   */
  traerInfoVelocidadTramos2(municipio: string | number, activo: any, todos: number, filter = '', pageIndex = 0, pageSize = 10, sort = { active: 'descripcion', direction: '' }) {
    return this.http.post(`${this.baseUrl}/TraerInfoVelocidadTramos2`, {
      municipio,
      activo,
      todos,
      filter,
      pageIndex,
      pageSize,
      sort
    });
  }

  guardarTramo2(data: any) {
    return this.http.post(`${this.baseUrl}/GuardarTramo2`, data);
  }

  SubirFotoTramo(FotoNueva, name) {
    let form: FormData = new FormData();
    form.append("Archivo", FotoNueva, name);
    return this.http.post(`${this.baseUrl}/SubirFotoTramo`, form);
  }

  TraerImagenTramo(Archivo) {
    const data = {
      Archivo: Archivo,
    };
    return this.http.post(`${this.baseUrl}/TraerImagenTramo`, data);
  }

  ElimininarImagenTramo(Archivo) {
    const data = {
      Archivo: Archivo,
    };
    return this.http.post(`${this.baseUrl}/EliminarFotoTramo`, data);
  }

  obtenerParametrosTramo() {
    return this.http.post(`${this.baseUrl}/obtenerParametrosTramo`, {});
  }

  TraerParaMetrosVelocidades(velMax) {
    const data = { velMax };

    return this.http.post(`${this.baseUrl}/ParaMetrosVelocidades`, data);
  }

  GuardarParaMetrosVelocidades(velMax, UmMin, UmMax) {
    const data = { velMax, UmMin, UmMax };

    return this.http.post(`${this.baseUrl}/AgregarParaMetrosVelocidades`, data);
  }

  ModificarParaMetrosVelocidades(Id, velMax, UmMin, UmMax) {
    const data = { Id, velMax, UmMin, UmMax };

    return this.http.post(
      `${this.baseUrl}/ModificarParaMetrosVelocidades`,
      data
    );
  }

  EliminarParaMetrosVelocidades(Id) {
    const data = { Id };

    return this.http.post(`${this.baseUrl}/EliminarParametroVelocidad`, data);
  }

  traerInfoMainMap(municipio, fecha) {
    const data = { municipio, fecha };

    return this.http.post(`${this.baseUrl}/traerInfoMainMap`, data);
  }

  /** 
   * Obtener informacion de tramos en el mapa
   * @param fecha fecha del evento
   * @param agrupacion number que representa la agrupacion
   * @param camaras array de camaras
   * @returns obervable con la informacion
   */
  obtenerInfoTramoMainMap(fecha: string, agrupacion: number, camaras: any[], idTramo: number = null): Observable<[{ ID_CAMARA: string, VMAX: number, VMEDIA: number, EXCESOS: number }]> {
    const data = { fecha, agrupacion, camaras, idTramo };
    return this.http.post<any>(`${this.baseUrl}/obtenerInfoTramoMainMap`, data);
  }

  /**
   * Trae informacion de camaras por fecha
   * @param fecha fecha del evento
   * @param camaras arreglo con los ids de las camras 
   * @param tiempo numero
   * @returns Observable
   */
  traerInfoEventoCamaraPorFecha(fecha: string, camaras: [{ id_camara: string }], tiempo: number, zonaHoraria): Observable<{ Camaras: any[], mensaje: string }> {
    const data = { fecha, camaras, tiempo, zonaHoraria };
    return this.http.post<any>(`${this.baseUrl}/traerInfoEventoCamaraPorFecha`, data);
  }

  /**
   * Obtener informacion de tramos en el mapa (vehiculos y flujo de velocidad)
   * @param camaras array de camaras
   * @param tipo number
   * @param fecha fecha del evento
   * @returns Observab con la informacion
   */
  traerInfoTraficoMainMap(camaras: any[], tipo: number, fecha: string): Observable<Traffic[]> {
    const data = { camaras, tipo, fecha };
    return this.http.post<Traffic[]>(`${this.baseUrl}/traerInfoTraficoMainMap`, data);
  }

  /**
   * Obtiene las listas de interés asociadas a un municipio
   * @param municipio id de municipio
   * @param activo estado
   * @param filter filtro que busca por descripcion de la lista
   * @param pageIndex indice de la pagina actual
   * @param pageSize cantidad de resgitros a obtener
   * @returns Observable
   */
  obtenerListasVehiculos(municipio: string | number, activo: boolean, filter = '', pageIndex: number, pageSize: number, sort = { active: 'descripcion', direction: '' }) {
    const data = {
      municipio,
      activo,
      filter,
      pageIndex,
      pageSize,
      sort
    };

    return this.http.post(`${this.baseUrl}/obtenerListasVehiculos`, data);
  }

  /**
   * Obtiene los datos de una lista en específico
   * @param idLista Id de la lista a obtener
   * @returns Datos de la lista
   */
  obtenerListaVehiculos(idLista: number) {
    const data = {
      activo: true,
      filter: '', pageIndex: 0,
      pageSize: 1,
      sort: { active: 'descripcion', direction: '' }
    };

    return this.http.post(`${this.baseUrl}/obtenerListaVehiculos/${idLista}`, data);
  }

  agregarListaVehiculos(
    descripcion,
    municipio,
    tipo,
    prioridad,
    notificacion_pantalla,
    notificacion_telegram,
    registrar,
    municipios_aliados,
    contactos_notificados,
    fecha_vigencia_inicial,
    fecha_vigencia_final,
    con_vigencia,
    propietario_lista,
    usuariosPantalla
  ) {
    const data = {
      descripcion,
      municipio,
      tipo,
      prioridad,
      notificacion_pantalla,
      notificacion_telegram,
      registrar,
      municipios_aliados,
      contactos_notificados,
      fecha_vigencia_inicial,
      fecha_vigencia_final,
      con_vigencia,
      propietario_lista,
      usuariosPantalla
    };

    return this.http.post(`${this.baseUrl}/agregarListaVehiculos`, data);
  }

  actualizarListaVehiculos(
    descripcion,
    activo,
    tipo,
    prioridad,
    id,
    notificacion_pantalla,
    notificacion_telegram,
    registrar,
    municipios_aliados,
    contactos_notificados,
    fecha_vigencia_inicial,
    fecha_vigencia_final,
    con_vigencia,
    usuariosPantalla
  ) {
    const data = {
      descripcion,
      activo,
      tipo,
      prioridad,
      id,
      notificacion_pantalla,
      notificacion_telegram,
      registrar,
      municipios_aliados,
      contactos_notificados,
      fecha_vigencia_inicial,
      fecha_vigencia_final,
      con_vigencia,
      usuariosPantalla
    };

    return this.http.post(`${this.baseUrl}/actualizarListaVehiculos`, data);
  }

  /**
   * Obtiene la lista de vehículos relacionados por conjunto (id) con paginación
   * @param id Número del conjunto
   * @param active Booleano para filtrar por estado activo
   * @param pageIndex Índice de la página para la paginación
   * @param pageSize Tamaño de la página para la paginación
   * @param fetchAll Booleano para obtener todos los datos
   * @returns Observable
   */
  obtenerListaVehiculosConjunto(id: number, active: boolean, pageIndex: number, pageSize: number, fetchAll: boolean): Observable<any> {
    const data = { id, active, pageIndex, pageSize, fetchAll };

    return this.http.post(`${this.baseUrl}/obtenerListaVehiculosConjunto`, data);
  }

  /**
   * Actualiza matricula de la lista de vehiculos conjunto
   * @param matricula matricula del coche
   * @param color color del coche
   * @param modelo modelo del coche
   * @param observaciones observaciones extra
   * @param idLista id de la lista
   * @param id id del registro
   * @param activo bandera que representa si esta activa o no la matricula en la lista
   * @returns Observable
   */
  actualizarListaVehiculosConjunto(
    matricula: string,
    color: string,
    modelo: string,
    observaciones: string,
    idLista: number,
    id: number,
    activo: boolean,
    fecha_vigencia_inicial: string,
    fecha_vigencia_final: string,
    con_vigencia: boolean,
  ) {
    const data = { matricula, color, modelo, observaciones, idLista, id, activo, fecha_vigencia_inicial, fecha_vigencia_final, con_vigencia };

    return this.http.post(
      `${this.baseUrl}/actualizarListaVehiculosConjunto`,
      data
    );
  }

  /**
   * Agrega un nuevo registro de matricula a una lista de interés
   * @param matriculas matricula del coche
   * @param color color del coche
   * @param modelo modelo del coche
   * @param observaciones observaciones extra
   * @param idLista id de la lista
   * @returns Observable
   */
  agregarMatriculaListaVehiculosConjunto(
    matriculas: string,
    color: string,
    modelo: string,
    observaciones: string,
    idLista: number,
    activo: boolean,
    fecha_vigencia_inicial: any,
    fecha_vigencia_final: any,
    con_vigencia: boolean,
  ) {
    const data = { matriculas, color, modelo, observaciones, idLista, activo, fecha_vigencia_inicial, fecha_vigencia_final, con_vigencia };
    return this.http.post(`${this.baseUrl}/agregarMatriculaListaVehiculosConjunto`, data);
  }

  /**
   * Verifica si una matricula ya existe en una determinada lista de interes
   * @param plate matricula 
   * @param idList id de la lista de interes
   * @returns Observable
   */
  getRegistrationPlateVehicleListSet(plate: string, idList: number): Observable<{ plate: VehiculoListaInteres[] }> {
    return this.http.get<any>(`${this.baseUrl}/getRegistrationPlateVehicleListSet/${plate}/${idList}`);
  }

  agregarListaVehiculosConjunto(matriculas, idLista) {
    const data = { matriculas, idLista };
    return this.http.post(
      `${this.baseUrl}/importarListaVehiculosConjunto`,
      data
    );
  }

  obtenerListaMayorPrioridad(id_municipio) {
    const data = { id_municipio };
    return this.http.post(`${this.baseUrl}/obtenerListaMayorPrioridad`, data);
  }

  obtenerMatriculaPorListas(idListas) {
    const data = { idListas };
    return this.http.post(`${this.baseUrl}/obtenerMatriculaPorListas`, data);
  }

  obtenerListasPorMatricula(matricula) {
    const data = { matricula };
    return this.http.post(`${this.baseUrl}/obtenerListasPorMatricula`, data);
  }

  obtenerSoportesMunicipioCamaraMatricula(municipio) {
    const data = { municipio };


    return this.http.post(
      `${this.baseUrl}/obtenerSoportesMunicipioCamaraMatricula`,
      data
    );
  }

  /**
   * Obtiene zbe por municipio
   * @param municipio id de municipio
   * @param activo boolean
   * @param filter filtro de busqueda por nombre
   * @param pageIndex Indice de la pagina actual
   * @param pageSize Cantidad de registros a obtener
   * @returns observable
   */
  ObtenerZbePorMunicipio(municipio: string | number, activo: boolean, filter: string, pageIndex: number, pageSize: number, sort = { active: 'z.nombre', direction: '' }) {
    const data = {
      municipio,
      activo,
      filter,
      pageIndex,
      pageSize,
      sort
    };
    return this.http.post(`${this.baseUrl}/obtenerZbePorMunicipio`, data);
  }

  /**
   * Crea una ZBE asociada a un municipio 
   * @param municipio id del municipio
   * @param nombre nombre del municipio
   * @param notificacion_pantalla tiene notificaciones por pantalla
   * @param notificacion_telegram tiene notificaciones por telegram
   * @param distintivos_ambientales distintivos ambientale seleccionados para esta zona
   * @param control_horario control de horario
   * @param comunicacion_infracciones comunicacion de infracciones
   * @returns Observable
   */
  crearZonaZbe(
    dataZbe: CreateZarDto
  ) {

    const data = {
      nombre: dataZbe.nombre,
      descripcion: dataZbe.descripcion,
      notificacion_telegram: dataZbe.notificacion_telegram,
      notificacion_pantalla: dataZbe.notificacion_pantalla,
      distintivos_ambientales: dataZbe.distintivos_ambientales,
      control_horario: dataZbe.control_horario,
      comunicacion_infracciones: dataZbe.comunicacion_infracciones,
      numero_archivos: dataZbe.numero_archivos,
      reiteracion: dataZbe.reiteracion,
      id_conf_formato: dataZbe.id_conf_formato,
      id_conf_envio: dataZbe.id_conf_envio,
      etapas_infracciones: dataZbe.etapas_infracciones,
      origen_matriculas: dataZbe.origen_matriculas,
      tipo_zona: dataZbe.tipo_zona,
      duracion: dataZbe.duracion,
      genera_infracciones: dataZbe.genera_infracciones,
    };

    return this.http.post(`${this.baseUrl}/crearZonaZbe`, data);
  }

  /**
   * Actualiza una ZBE
   * @param nombre Nombre del zbe
   * @param activo Estado del zbe
   * @param id id de ZBE
   * @param notificacion_pantalla tiene notificaciones por pantalla
   * @param notificacion_telegram tiene notificaciones por telegram
   * @param distintivos_ambientales distintivos ambientale seleccionados para esta zona
   * @param control_horario control de horario
   * @param comunicacion_infracciones comunicacion de infracciones
   * @returns Observable
   */
  actualizarZonaZbe(
    dataZbe: UpdateZarDto & CreateZarDto
  ) {
    const data = {
      ...dataZbe
    };

    return this.http.post(`${this.baseUrl}/actualizarZonaZbe`, data);
  }

  agregarCamarasZbe(idZbe, camarasAgregadas, camarasEliminadas) {
    const data = { camarasAgregadas, camarasEliminadas, idZbe };
    return this.http.post(`${this.baseUrl}/agregarCamarasZbe`, data);
  }

  agregarListasZbe(idZbe, listasAgregadas, listasEliminadas) {
    const data = { listasAgregadas, listasEliminadas, idZbe };
    return this.http.post(`${this.baseUrl}/agregarListasZbe`, data);
  }

  modificarCamarasZbe(idZbe, camarasModificadas) {
    const data = { camarasModificadas, idZbe };
    return this.http.post(`${this.baseUrl}/modificarCamarasZbe`, data);
  }

  /**
   * Trae los tipos de zona para ZBE desde el backend
   * Endpoint esperado: TraerTiposZonaZbe
   */
  TraerTiposZonaZbe() {
    const data = {};
    return this.http.post(`${this.baseUrl}/TraerTiposZonaZbe`, data);
  }

  /**
   * Trae las cámaras que pertenecen a una ZAR
   * @param idZbe Id de zona
   * @param activo Si se traen las cámaras activas o inactivas (1,0)
   * @returns 
   */
  obtenerCamarasZbe(idZbe, activo: boolean) {
    const data = { idZbe, activo };
    return this.http.post(`${this.baseUrl}/obtenerCamarasZbe`, data);
  }

  obtenerListasZbe(idZbe) {
    const data = { idZbe };
    return this.http.post(`${this.baseUrl}/obtenerListasZbe`, data);
  }

  obtenerRutas(activo) {
    var data = { activo };

    return this.http.post(`${this.baseUrl}/obtenerRutas`, data);
  }

  crearRuta(nombre, ruta, tipo) {
    var data = { nombre, ruta, tipo };

    return this.http.post(`${this.baseUrl}/crearRuta`, data);
  }

  actualizarRuta(nombre, ruta, tipo, activo, id) {
    var data = { nombre, ruta, tipo, activo, id };

    return this.http.post(`${this.baseUrl}/actualizarRuta`, data);
  }

  obtenerRoles(activo) {
    const idMunicipio = Number(this.fsession.optenerValor("dato4"));
    const idRol = Number(this.fsession.optenerValor("dato40"));
    const data = { idRol, idMunicipio, activo };

    return this.http.post(`${this.baseUrl}/obtenerRoles`, data);
  }

  /**
   * Crea el registro de rol (sin permisos). Los permisos se asignan con updateRolePermission.
   * @param id_municipio null si el rol es global (usuario no limitado)
   * @param global 1 rol global, 0 rol de municipio
   */
  crearRol(nombre: string, descripcion: string, id_municipio: number | null, global: number) {
    const data = { nombre, descripcion, id_municipio, global };
    return this.http.post(`${this.baseUrl}/crearRol`, data);
  }

  /**
   * Actualiza datos del rol (nombre, descripcion, municipio, global, activo).
   */
  actualizarRol(
    id: number | string,
    nombre: string,
    descripcion: string,
    id_municipio: number | null,
    activo: boolean,
    global: number
  ) {
    const data = { id, nombre, descripcion, id_municipio, activo, global };
    return this.http.post(`${this.baseUrl}/actualizarRol`, data);
  }

  obtenerTiposUsuario(activo = 1) {
    var data = { activo };
    return this.http.post(`${this.baseUrl}/obtenerTiposUsuario`, data);
  }

  crearTipoUsuario(nombre) {
    var data = { nombre };
    return this.http.post(`${this.baseUrl}/crearTipoUsuario`, data);
  }

  actualizarTipoUsuario(nombre, activo, id) {
    var data = { nombre, activo, id };
    return this.http.post(`${this.baseUrl}/actualizarTipoUsuario`, data);
  }

  obtenerRutasPorRol(id_rol) {
    var data = { id_rol };

    return this.http.post(`${this.baseUrl}/obtenerRutasPorRol`, data);
  }

  crearRutasPorRol(id_rol, id_ruta) {
    var data = { id_rol, id_ruta };

    return this.http.post(`${this.baseUrl}/crearRutasPorRol`, data);
  }

  eliminarRutasPorRol(id_rol, id_ruta) {
    var data = { id_rol, id_ruta };

    return this.http.post(`${this.baseUrl}/eliminarRutasPorRol`, data);
  }

  traerUltImagenesVisorAdmin(cantidad, ArrayCamaras) {
    return this.http.post(`${this.baseUrl}/TraerUltImagenesVisorAdmin`, {
      cantidad,
      ArrayCamaras,
    });
  }

  /**
   * Trae lista de fotor rojo
   * @param municipio id de municipio
   * @param activo estado
   * @param nombre nombre
   * @param pageIndex indice de pagina actual
   * @param pageSize cantidad de registros a obtener
   * @returns observable
   */
  traerFotoRojo(municipio, activo, nombre, pageIndex: number, pageSize: number, sort = { active: '', direction: '' }) {
    let data = { municipio, activo, nombre, pageIndex, pageSize, sort };

    return this.http.post(`${this.baseUrl}/traerFotoRojo`, data);
  }

  crearFotoRojo(
    nombre,
    camara,
    router,
    municipio,
    segundos_deteccion_ini,
    segundos_deteccion_fin
  ) {
    let data = {
      nombre,
      camara,
      router,
      municipio,
      segundos_deteccion_ini,
      segundos_deteccion_fin,
    };

    return this.http.post(`${this.baseUrl}/crearFotoRojo`, data);
  }

  actualizarFotoRojo(
    id,
    nombre,
    camara,
    router,
    activo,
    segundos_deteccion_ini,
    segundos_deteccion_fin
  ) {
    let data = {
      id,
      nombre,
      camara,
      router,
      activo,
      segundos_deteccion_ini,
      segundos_deteccion_fin,
    };

    return this.http.post(`${this.baseUrl}/actualizarFotoRojo`, data);
  }

  /**
   * Obtiene las cámaras de paso cebra asociadas a un municipio
   * @param municipio id del Municipio
   * @param activo Estado
   * @param pageIndex indice de la pagina actual
   * @param pageSize cantidad de registros a obtener
   * @param search coincidencia por nombre
   * @returns Observable
   */
  traerFotoCebra(municipio: string | number, activo: boolean, pageIndex: number, pageSize: number, search: string, sort = { active: '', direction: '' }) {
    let data = { municipio, activo, pageIndex, pageSize, search, sort };
    return this.http.post(`${this.baseUrl}/traerFotoCebra`, data);
  }

  crearFotoCebra(
    nombre,
    camara_1,
    router_1,
    camara_2,
    router_2,
    municipio,
    segundos_deteccion_ini_1,
    segundos_deteccion_fin_1,
    segundos_deteccion_ini_2,
    segundos_deteccion_fin_2,
    carril_1,
    carril_2,
    entrada_1,
    entrada_2
  ) {
    let data = {
      nombre,
      camara_1,
      router_1,
      camara_2,
      router_2,
      municipio,
      segundos_deteccion_ini_1,
      segundos_deteccion_fin_1,
      segundos_deteccion_ini_2,
      segundos_deteccion_fin_2,
      carril_1,
      carril_2,
      entrada_1,
      entrada_2
    };
    return this.http.post(`${this.baseUrl}/crearFotoCebra`, data);
  }

  actualizarFotoCebra(
    id,
    nombre,
    camara_1,
    router_1,
    camara_2,
    router_2,
    activo,
    segundos_deteccion_ini_1,
    segundos_deteccion_fin_1,
    segundos_deteccion_ini_2,
    segundos_deteccion_fin_2,
    carril_1,
    carril_2,
    entrada_1,
    entrada_2
  ) {
    let data = {
      id,
      nombre,
      camara_1,
      router_1,
      camara_2,
      router_2,
      activo,
      segundos_deteccion_ini_1,
      segundos_deteccion_fin_1,
      segundos_deteccion_ini_2,
      segundos_deteccion_fin_2,
      carril_1,
      carril_2,
      entrada_1,
      entrada_2
    };
    return this.http.post(`${this.baseUrl}/actualizarFotoCebra`, data);
  }

  /**
   * Obtiene url de conexion
   * @param idMunicipality id del municipio
   * @returns Observable
   */
  getURLConnection(idMunicipality: number): Observable<NotificationConnection> {
    return this.http.post<any>(`${this.baseUrl}/obtenerURLConexion`, { idMunicipality });
  }

  TraerArchivoAlerta(Archivo) {
    const data = {
      Archivo: Archivo,
    };
    return this.http.post(`${this.baseUrl}/TraerArchivoAlerta`, data);
  }

  /**
   * Trae el historial no notificaciones enviado al municipio en un rango específico.
   * @param fechaIni Fecha inicio del rango
   * @param fechaFin Fecha fin del rango
   * @param municipio id del Municipio
   * @param pageIndex indice de pagina actual
   * @param pageSize cantidad de regitros a obtener
   * @returns observable
   */
  traerRegistroNotificacionesMunicipio(
    fechaIni: string,
    fechaFin: string,
    municipio: string | number,
  ) {
    let data = { fechaIni, fechaFin, municipio };
    return this.http.post(`${this.baseUrl}/registroNotificaciones`, data);
  }
  obtenerInfraccionesConfirmadas(municipio, fechaIni, fechaFin) {
    return this.http.post(`${this.baseUrl}/obtenerInfraccionesConfirmadas`, {
      municipio,
      fechaIni,
      fechaFin
    });
  }
  obtenerTotalInfracciones(municipio) {
    return this.http.post(`${this.baseUrl}/obtenerTotalInfracciones`, {
      municipio,
    });
  }
  obtenerUrlInfraccion(archivo_ZIP, confirmada) {
    return this.http.post(`${this.baseUrl}/obtenerUrlInfraccion`, {
      archivo_ZIP,
      confirmada
    });
  }

  marcarFalsoRojo(id_eventoscam, falso_rojo, tipo_infraccion) {
    let data = { id_eventoscam, falso_rojo, tipo_infraccion };

    return this.http.post(`${this.baseUrl}/marcarFalsoRojo`, data);
  }

  traerVariablesTelemetria() {
    return this.http.post(`${this.baseUrl}/traerVariablesTelemetria`, {});
  }

  traerTelemetriaRouter(router, filtroMedicion, fechaIni, fechaFin, municipio) {
    let data = { router, filtroMedicion, fechaIni, fechaFin, municipio };

    return this.http.post(`${this.baseUrl}/traerTelemetriaRouter`, data);
  }

  traerEtiquetaMedioambiental(matricula) {
    let data = { matricula };
    return this.http.post<{ url: string; nombre: string }>(
      `${this.baseUrl}/traerEtiquetaMedioambiental`,
      data
    );
  }

  lecturasBruto(routerId) {
    return this.http.post(`${this.baseUrl}/lecturasBrutoClima`, { routerId });
  }

  lecturasCuartaHoraria(routerId) {
    return this.http.post(`${this.baseUrl}/lecturasCuartaHorariaClima`, {
      routerId,
    });
  }

  lecturasHoraClima(routerId, fecha, tipoLectura = "avg") {
    var idioma = this.fsession.optenerValor("language");
    return this.http.post(`${this.baseUrl}/lecturasHoraClima`, {
      routerId,
      fecha,
      tipoLectura,
      idioma,
    });
  }
  lecturasHoraClimaV2(routerId, fecha, tipoLectura = "avg") {
    var idioma = this.fsession.optenerValor("language");
    return this.http.post(`${this.baseUrl}/lecturasHoraClimaV2`, {
      routerId,
      fecha,
      tipoLectura,
      idioma,
    });
  } traerTelemetriaCargaSolar(
    router,
    filtroMedicion,
    fechaIni,
    fechaFin,
    municipio
  ) {
    return this.http.post(`${this.baseUrl}/lecturasCargaSolar`, {
      idRouter: router,
      filtroMedicion,
      fechaIni,
      fechaFin,
      municipio,
    });
  }

  traerTelemetriaClima(router, filtroMedicion, fechaIni, fechaFin, municipio) {
    let data = {
      router,
      filtroMedicion,
      fechaIni,
      fechaFin,
      municipio,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    };
    return this.http.post(`${this.baseUrl}/traerTelemetriaClima`, data);
  }

  obtenerModulos() {
    return this.http.get(`${this.baseUrl}/obtenerPaqueteRutas`);
  }

  obtenerModulosMunicipio(IdMunicipio) {
    var data = { IdMunicipio };
    return this.http.post(`${this.baseUrl}/obtenerModulosMunicipio`, data);
  }

  actualizarModuloMunicipio(id_municipio, permission) {
    var data = { id_municipio, permission };
    return this.http.post(`${this.baseUrl}/actualizarModuloMunicipio`, data);
  }

  getRolePermission() {
    return this.http.get(`${this.baseUrl}/getRolePermission`);
  }

  getModules() {
    return this.http.get(`${this.baseUrl}/getModules`);
  }

  updateRolePermission(id_rol, addedPermissions, deletedPermissions, specialPermissions) {
    var data = { id_rol, addedPermissions, deletedPermissions, specialPermissions };
    return this.http.post(`${this.baseUrl}/updateRolePermission`, data);
  }

  /**
   * Obtiene los cálculos de detecciones de matrículas de cámaras con paginación.
   * @param idMunicipio Identificador del municipio.
   * @param fechaI Fecha de inicio.
   * @param fechaF Fecha de fin.
   * @param camarasMatricula Lista de cámaras.
   * @param pageIndex Índice de la página actual para la paginación.
   * @param pageSize Cantidad de registros por página.
   * @returns Observable con los datos de detecciones.
   */
  traerCalculosDetecciones(idMunicipio, fechaI, fechaF, camarasMatricula, pageIndex, pageSize) {
    const data = {
      idMunicipio,
      fechaI,
      fechaF,
      camarasMatricula,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      pageIndex,
      pageSize
    };
    return this.http.post<any>(`${this.baseUrl}/traerCalculosDetecciones`, data);
  }

  obtenerUrlManual() {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/obtenerUrlManualUsuario`, {
      idioma,
    });
  }

  subirManuales(formData) {
    return this.http.post(`${this.baseUrl}/cargarManualesUsuario`, formData);
  }

  importarUsuarioAzure(usuario) {
    return this.http.post(`${this.baseUrl}/importarUsuarioAzure`, {
      ...usuario,
    });
  }

  getModulosPermisosRol(IdUsuario: number, IdMunicipio: number) {
    const data = { IdMunicipio };
    return this.http.post<{ accessToken: string, refreshToken: string }>(`${configuracion.servidor_api}/auth/token`, data);
  }

  municipalityRefreshToken() {
    const refreshToken = this.fsession.optenerValor('refreshToken', 'municipality');
    return this.http.post<{ accessToken: string, refreshToken: string }>(`${configuracion.servidor_api}/auth/refresh`, { refreshToken });
  }

  getInfoInicialMunicipio() {
    return this.http.get<{ municipio: any }>(`${this.baseUrl}/getInfoInicialMunicipio`);
  }

  getPermisosXrol(id_rol: number) {
    const data = { id_rol }
    return this.http.post(`${this.baseUrl}/getPermisosXrol`, data);
  }

  /**
   * Obtiene tipos de permisos para una ruta
   * @returns Observable con el valor de terminoEns
   */
  TraerTiposPermisos(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/getTiposPermiso`);
  }

  getNamesUserRolPorMunicipio(idMunicipio) {
    const data = { idMunicipio }
    return this.http.post(`${this.baseUrl}/getNamesUserRolPorMunicipio`, data);
  }

  getEstadoMatricula() {
    return this.http.get(`${this.baseUrl}/getEstadoMatricula`);
  }

  /**
  * Retorna si un usuario es superadmin o no
  * @param idUsuario id del usuario
  * @returns observable
  */
  getUserIsSuperAdmin(idUsuario: number): Observable<{ isSuperAdmin: boolean }> {
    return this.http.get<any>(`${this.baseUrl}/getUserIsSuperAdmin/${idUsuario}`)
  }

  /**
   * Determina si un usuario es administrador de un municipio
   * @param idUsuario id de usuario
   * @param idMunicipio id de municipio
   * @returns observable
   */
  getIsMunicipalityAdministratorUser(idUsuario: number, idMunicipio: number): Observable<{ isAdmin: boolean }> {
    return this.http.get<any>(`${this.baseUrl}/getIsMunicipalityAdministratorUser/${idUsuario}/${idMunicipio}`);
  }

  /**
   * Trae las detecciones para una matrícula en un rango determinado en todo el municipio
   * @param matricula Matricula
   * @param fecha Fecha a Consultar
   * @param tipo Rango de fecha
   * @returns observable
   */
  TrazabilidadMatricula(matricula, fecha, tipo, idmunicipio) {
    return this.http.post(`${this.baseUrl}/TrazabilidadMatricula`, {
      matricula,
      fecha,
      tipo,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      idmunicipio
    });
  }

  ObtenerDetecciones(IdMunicipio: number, id_router: number, Filtro: any, StartDate: string, EndDate: string) {
    const data = { IdMunicipio, id_router, Filtro, StartDate, EndDate, zonaHoraria: this.fsession.optenerValor("dato41"), };
    return this.http.post(`${this.baseUrl}/ObtenerDetecciones`, data);
  }

  traerGraficosAforo(acceso, tipo, fecha, titulo, fechaFin = null, pais, vehiculo, pegatina) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosAforo`, {
      acceso,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      pais,
      vehiculo,
      pegatina,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }
  traerGraficosAforoV2(acceso, tipo, fecha, titulo, fechaFin = null, pais, vehiculo, pegatina) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosAforoV2`, {
      acceso,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      pais,
      vehiculo,
      pegatina,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  /**
   * Trae los graficos de aforo para Zona ZBE Estadística
   * @param IDZBE ID de la ZBE
   * @param acceso Acceso a la grafica
   * @param tipo Tipo de grafico
   * @param fecha Fecha a consultar
   * @param titulo Titulo de la grafica
   * @param fechaFin Fecha fin para el rango de fechas
   * @param pais Pais
   * @param vehiculo Vehiculo
   * @param pegatina Pegatina
   * @returns observable
   */
  traerGraficosAforoZBE(IDZBE, acceso, tipo, fecha, titulo, fechaFin = null, pais, vehiculo, pegatina, accesoCamara = null) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosAforoZBE`, {
      IDZBE,
      acceso,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      pais,
      vehiculo,
      pegatina,
      accesoCamara,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }
  traerGraficosAforoZBEV2(IDZBE, acceso, tipo, fecha, titulo, fechaFin = null, pais, vehiculo, pegatina, accesoCamara = null) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosAforoZBEV2`, {
      IDZBE,
      acceso,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      pais,
      vehiculo,
      pegatina,
      accesoCamara,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  traerGraficosPersonas(origen, agregacion, fecha, tituloTooltips, fechaFin = null, zoneId, groupName) {
    const idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosPersonas`, {
      origen,
      agregacion,
      fecha,
      idioma,
      tituloTooltips,
      fechaFin,
      zoneId,
      groupName,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }
  traerGraficosPersonasV2(origen, agregacion, fecha, tituloTooltips, fechaFin = null, zoneId, groupName) {
    const idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosPersonasV2`, {
      origen,
      agregacion,
      fecha,
      idioma,
      tituloTooltips,
      fechaFin,
      zoneId,
      groupName,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  traerGraficosConteo(origen, agregacion, fecha, tituloTooltips, fechaFin = null, zoneId, groupName) {
    const idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosPanelConteo`, {
      origen,
      agregacion,
      fecha,
      idioma,
      tituloTooltips,
      fechaFin,
      zoneId,
      groupName,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }
  traerGraficosConteoV2(origen, agregacion, fecha, tituloTooltips, fechaFin = null, zoneId, groupName) {
    const idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosPanelConteoV2`, {
      origen,
      agregacion,
      fecha,
      idioma,
      tituloTooltips,
      fechaFin,
      zoneId,
      groupName,
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  traerGraficosRemolques(acceso, tipo, fecha, titulo, fechaFin = null) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosRemolques`, {
      acceso,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }
  traerGraficosRemolquesV2(acceso, tipo, fecha, titulo, fechaFin = null) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosRemolquesV2`, {
      acceso,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  traerDeteccionesRemolque(matricula, fecha, fechaFin = null, agregacion, tipo) {
    return this.http.post(`${this.baseUrl}/traerDeteccionesRemolque`, {
      matricula,
      fecha,
      fechaFin,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41"),
      agregacion,
      tipo,
    });
  }

  traerDeteccionesParking(matricula, fecha, fechaFin = null, agregacion, id_parking) {
    return this.http.post(`${this.baseUrl}/traerDeteccionesParking`, {
      matricula,
      fecha,
      fechaFin,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41"),
      agregacion,
      id_parking,
    });
  }

  exportarDatosAforo(acceso, tipo, fecha, titulo, fechaFin = null) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/exportarDatosAforo`, {
      acceso,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  refrescarEstadisticas() {
    return this.http.post(`${this.baseUrl}/refrescarEstadisticas`, {});
  }

  traerMatriculasAforo(acceso, tipo, fecha) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerMatriculasAforo`, {
      acceso,
      tipo,
      fecha,
      idioma,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }

  /**
   * Obtiene los usuarios por municipio y rol
   * @param id_rol identificado de rol
   * @param search cadena de busqueda
   * @param pageIndex Index actual de la paginacion
   * @param pageSize cantidad de registro por paginas
   * @returns observable
   */
  getUsersXmunicipioXrol(
    id_rol: number, search: string, pageIndex: number, pageSize: number
  ): Observable<{ TotalRegistros: number, municipios: string, usuario: string }[]> {
    const data = { id_rol, search, pageIndex, pageSize }
    return this.http.post<any>(`${this.baseUrl}/getUsersXmunicipioXrol`, data);
  }

  /**
   * Obtiene la informacion de las matriculas de paso cebra 
   * @param dateInit tiempo inicial
   * @param idZebraCrossing id del paso cebra seleccionado
   * @returns Observable
   */
  getLicensePlatesZebraCrossing(dateInit: Moment, idZebraCrossing: number): Observable<{ result: RespuestaSimulacionPasoCebra[] }> {
    return this.http.get<any>(`${this.baseUrl}/getLicensePlatesZebraCrossing/${dateInit}/${idZebraCrossing}`);
  }

  /**
   * Obtener certificado
   * @param name nombre del certificado
   * @returns 
   */
  getCertificados(name) {
    const data = { name: name }
    return this.http.post<any>(`${this.baseUrl}/DescargarCertificacion`, data);
  }

  addContacts(IdMunicipio, nombre_contacto, numero_contacto, activo, contacto_generico, alarma_telemetria, alarma_infracciones, alarma_lista) {
    const data = { IdMunicipio, nombre_contacto, numero_contacto, activo, alarma_telemetria, alarma_infracciones, alarma_lista, contacto_generico }
    return this.http.post<any>(`${this.baseUrl}/addContacts`, data);
  }

  updateContacts(idContacto, nombre_contacto, numero_contacto, activo, contacto_generico, alarma_telemetria, alarma_infracciones, alarma_lista) {
    const data = { idContacto, nombre_contacto, numero_contacto, activo, alarma_telemetria, alarma_infracciones, alarma_lista, contacto_generico }
    return this.http.post<any>(`${this.baseUrl}/updateContacts`, data);
  }

  /**
   * Trae los contacto del municipio actual (si no se le pasa id) o los del municipio especificado
   * 
   * @param IdMunicipio Id d el municipio
   * @param pageIndex Index de la página a mostrar
   * @param pageSize Tamaño de la página
   * @param alarmaLista Incluir contactos con alarmas de lista (Negra y Blanca)
   * @param alarmaIntrusion Incluir contactos con alarmas de intrusión
   * @param alarmaTelemetria Incluir contactos con alarmas de telemetría
   */
  getAllContacts(IdMunicipio, pageIndex, pageSize, sort = { active: 'nombre_contacto', direction: '' }) {
    let data: any = { pageIndex, pageSize };

    if (IdMunicipio) {
      data = { ...data, IdMunicipio, sort };
    }

    return this.http.post<any>(`${this.baseUrl}/getAllContacts`, data);
  }

  /**
   * Trae los contacto disponibles para listas de interés del municipio actual (si no se le pasa id) o los del municipio especificado
   * 
   * @param IdMunicipio Id d el municipio
   * @param pageIndex Index de la página a mostrar
   * @param pageSize Tamaño de la página
   * @param alarmaLista Incluir contactos con alarmas de lista (Negra y Blanca)
   * @param alarmaIntrusion Incluir contactos con alarmas de intrusión
   * @param alarmaTelemetria Incluir contactos con alarmas de telemetría
   */
  getAllContactsLists(IdMunicipio, pageIndex, pageSize) {
    let data: any = { pageIndex, pageSize };

    if (IdMunicipio) {
      data = { ...data, IdMunicipio };
    }

    return this.http.post<any>(`${this.baseUrl}/getAllContactsLists`, data);
  }

  verifyInputsCamara(Ip: string, id_camara: string, nombre: string, cameraId: number) {
    const data = { Ip, id_camara, nombre, cameraId }
    return this.http.post<any>(`${this.baseUrl}/verifyInputsCamara`, data);
  }

  /**
   * Crea un nuevo grupo
   * @param groupName nombre del grupo 
   * @param cameras lista de camaras del grupo
   * @param idMunicipality id de municipio donde pertenece el grupo
   * @returns Observable
   */
  createGroup(groupName: string, cameras: string, idMunicipality: number): Observable<any> {
    const data = {
      nombre_grupo: groupName,
      camaras: cameras,
      idMunicipio: idMunicipality
    }
    return this.http.post(`${this.baseUrl}/createGroup`, data);
  }

  /**
   * Edita Grupo y Grupo de camaras
   * @param idGroup id de grupo
   * @param groupName nombre de grupo
   * @param cameras array en formato json de camaras
   * @returns Observable
   */
  editGroup(idGroup: number, groupName: string, cameras: string): Observable<any> {
    const data = {
      idGrupo: idGroup,
      nombre_grupo: groupName,
      camaras: cameras
    };
    return this.http.put(`${this.baseUrl}/editGroup`, data);
  }

  /**
   * Obtiene grupos por municipio
   * @param idMunicipality id de municipio
   * @param search coincidencia por nombre del grupo
   * @param pageIndex indice de pagina actual
   * @param pageSize cantidad de registros a obtener
   * @returns Observable
   */
  getGroupsByMunicipality(idMunicipality: number, search: string, pageIndex: number = null, pageSize: number = null): Observable<Group[]> {
    const data = {
      idMunicipio: idMunicipality,
      search,
      pageIndex,
      pageSize
    }
    return this.http.post<any>(`${this.baseUrl}/getGroupsByMunicipality`, data);
  }

  /**
   * Retorna los grupos de camara por id del grupo
   * @param idGroup id de grupo
   * @returns Observable
   */
  getCameraGroupsByMunicipality(idGroup: number, idMunicipio: number): Observable<CamerasFilteredByGroup[]> {
    return this.http.get<CamerasFilteredByGroup[]>(`${this.baseUrl}/getCameraGroupsByMunicipality/${idMunicipio}/${idGroup}`);
  }

  /**
   * Obtener grupo por nombre
   * @param nameGroup nombre a comparar
   * @returns Observable
   */
  getGroupByName(nameGroup: string, idMunicipality: number): Observable<Group[]> {
    return this.http.get<any>(`${this.baseUrl}/getGroupByName/${nameGroup}/${idMunicipality}`);
  }

  /**
   * Guarda la configuracion de un grupo en el visor rotativo
   * @param idGroup id de grupo
   * @param settings configuraciones
   * @returns Observable
   */
  saveSettingsViewerRotating(idGroup: number, settings: SettingsViewerRotating): Observable<any> {
    const data = { idGroup, settings: JSON.stringify(settings) };
    return this.http.put(`${this.baseUrl}/saveSettingsViewerRotating`, data);
  }

  /**
   * Obtiene la configuracion de un grupo
   * @param idGroup id de grupo
   * @returns Observable
   */
  getSettingsViewerRotatingInGroup(idGroup: number): Observable<any[]> {
    return this.http.get<any>(`${this.baseUrl}/getSettingsViewerRotatingInGroup/${idGroup}`);
  }

  /**
   * Obtiene informacion de la tabla "marcas"
   * @returns Observable
   */
  getBrands(): Observable<Brand[]> {
    return this.http.get<Brand[]>(`${this.baseUrl}/getBrands`);
  }

  /**
   * Obtiene informacion de la tabla colores
   * @returns Observable
   */
  getColors(): Observable<Color[]> {
    return this.http.get<Color[]>(`${this.baseUrl}/getColors`);
  }

  getinfoSoporte(IdSoporte: number) {
    const data = { IdSoporte: IdSoporte }
    return this.http.post(`${this.baseUrl}/getinfoSoporte`, data);
  }

  /**
   * Obtiene consumo de router por su id
   * @param idRouter id de router
   * @param idMunicipality id de municipio
   * @param initialDate fecha inicial de busqueda
   * @param finalDate fecha final de busqueda
   * @param pageIndex indice de la pagina actual 
   * @param pageSize numero de resultados a obtener en la busqueda
   * @returns Observable
   */
  getRouterConsumption(
    idRouter: number,
    idMunicipality: number,
    initialDate: string,
    finalDate: string,
    pageIndex: number,
    pageSize: number
  ): Observable<RouterConsumption[]> {
    const data = {
      idRouter, idMunicipality, initialDate, finalDate, pageIndex, pageSize, zonaHoraria: this.fsession.optenerValor("dato41"),
    };
    return this.http.post<any>(`${this.baseUrl}/getRouterConsumption`, data);
  }

  /**
   * Obtiene datos de alimentacion y bateria de los routers de un municipio
   * @param idMunicipality id de municipio
   * @param startDate fecha de inicio para el filtro de fecha_ultima_conexion
   * @param endDate fecha final para el filtro de fecha_ultima_conexion
   * @param routerId id del router a filtrar
   * @param pageIndex indice de la pagina actual 
   * @param pageSize numero de resultados a obtener en la busqueda
   * @returns Observable
   */
  getPowerBatteryDataFromRouters(idMunicipality: number, startDate: string, endDate: string, routerId: number, pageIndex: number, pageSize: number): Observable<RoutersDataPowerAndBattery[]> {
    const data = { idMunicipality, startDate, endDate, routerId, pageIndex, pageSize };
    return this.http.post<any>(`${this.baseUrl}/getPowerBatteryDataFromRouters`, data);
  }

  /**
   * Guarda la configuracion de campos de matricula
   * @param configuracion Lista de campos
   * @returns 
   */
  updateConfigurationMatr(configuracion: string) {
    const data = { configuracion };
    return this.http.post<any>(`${this.baseUrl}/updateConfigurationMatr`, data);
  }

  /**
   * Guarda un nuevo registro en la tabla "DescargasPendientesImg" y actualiza la propiedad "estado_imagen" del elemento -
   * en la tabla "EventosCam"
   * @param idEventsCam id que representa un registro en la tabla "EventosCam"
   * @param idUser id del usuario
   * @returns Observable
   */
  saveDownloadsPendingsImg(idEventsCam: number, idUser: number): Observable<any> {
    const data = { idEventsCam, idUser };
    return this.http.post(`${this.baseUrl}/saveDownloadsPendingsImg`, data);
  }

  /**
   * Actualiza la propiedad "estado" de la tabla "DescargasPendientesImg" y la propiedad "estado_imagen" de la tabla "EventosCam" 
   * @param idEventsCam id que representa un registro en la tabla "EventosCam"
   * @returns Observable
   */
  saveUpdateStatusInPendingDownloadsImgAndCamEvents(idEventsCam: number): Observable<any> {
    const data = { idEventsCam };
    return this.http.put(`${this.baseUrl}/saveUpdateStatusInPendingDownloadsImgAndCamEvents`, data);
  }

  /**
   * Obtiene varios registro de la tabla "EventosCam"
   * @param idsEventsCam ids de eventos cam 
   * @returns Observable
   */
  getEventsCamLogs(idsEventsCam: number[]): Observable<Pick<EventosCam, 'id' | 'id_camara' | 'estado_imagen'>[]> {
    const data = { idsEventsCam };
    return this.http.post<any>(`${this.baseUrl}/getEventsCamLogs`, data);
  }

  /**
   * Trae las aplicaciones hablitadas desde azure para el usuario
   * @param azure_oid Id de Usuario en Azure
   * @returns Observable
   */
  getEnabledApps(azure_oid: string): Observable<any> {
    const data = { azure_oid };
    return this.http.post<any>(`${this.baseUrl}/getEnabledApps`, data);
  }

  /**
 * Guarda las aplicaciones habilitadas para el usuario
 * @param azure_oid Id de Usuario en Azure
 * @param data Arreglo de aplicaciones
 * @returns Observable
 */
  saveEnabledApp(azure_oid: string, apps: string[]): Observable<any> {
    const data = { azure_oid, apps };
    return this.http.post<any>(`${this.baseUrl}/saveEnabledApps`, data);
  }

  /**
   * Resetea autenticacion del usuario en B2C.
   * @param azure_oid Id del usuario en Azure B2C
   * @param resetPassword bandera para resetear contrasena
   * @param resetTotp bandera para resetear authenticator
   * @returns Observable con estado de la operacion
   */
  resetUserB2CAuth(
    azure_oid: string,
    resetPassword: boolean,
    resetTotp: boolean,
  ): Observable<ResetAuthenticationResponse> {
    const data = {
      azure_oid,
      resetPassword,
      resetTotp,
    };
    return this.http.post<ResetAuthenticationResponse>(`${this.baseUrl}/resetUserB2CAuth`, data);
  }

  /**
   * Actualiza campo de matricula en vehiculos db
   * @param idEventCam ids de eventos cam
   * @param newMatricula nueva matricula
   * @param matriculaAnterior matricula a cambiar
   * @returns Observable
   */
  updateMatricula(idEventCam, newMatricula, matriculaAnterior) {
    const data = { idEventCam: idEventCam, newMatricula: newMatricula, matriculaAnterior: matriculaAnterior };
    return this.http.post<any>(`${this.baseUrl}/updateMatricula`, data);
  }

  /**
   * Obtener matricula
   * @param idEventCam ids de eventos cam 
   * @returns Observable
   */
  getMatricula(idEventCam) {
    const data = { idEventCam: idEventCam };
    return this.http.post<any>(`${this.baseUrl}/getMatricula`, data);
  }

  /**
   * Envia notificacion utilizando el api de notificaciones 
   * @param channel canal a enviar el mensaje al momento soporta telegram como medio 
   * @param body cuerpo del mensaje a enviar 
   * @returns Observable
   */
  sendTestNotification(channel: 'telegram', content: NotificationTestBody): Observable<ResponseNotificationTest> {
    return this.http.post<ResponseNotificationTest>(`${this.baseUrl}/enviarTestNotificacion`, { channel, content });
  }

  /**
   * Envia notificacion de prueba de matricula
   * @param idUser id de usuario al cual se le enviara la notificacion
   * @returns 
   */
  sendTestNotificationPlate(idUser: string): Observable<ResponseNotificationTest> {
    return this.http.post<ResponseNotificationTest>(`${this.baseUrl}/sendTestNotificationPlate`, { idUser });
  }

  /**
   * Obtiene usuarios por municipio
   * @param userName nombre de usuario
   * @param idMunicipality id de municipio
   * @param viewUsersB2C bandera que determina si se deben mostrar solo los usuario que tengan el acceso desde el B2C
   * @param pageIndex indice de la pagina actual 
   * @param pageSize numero de resultados a obtener en la busqueda
   * @returns Observable
   */
  getUsersByMunicipality(
    userName: string, idMunicipality: number, viewUsersB2C: boolean, pageIndex: number, pageSize: number
  ): Observable<UsersByMunicipality[]> {

    const data = { userName, idMunicipality, viewUsersB2C, pageIndex, pageSize };
    return this.http.post<any>(`${this.baseUrl}/getUsersByMunicipality`, data);
  }

  traerParkingsMunicipio() {
    return this.http.post(`${this.baseUrl}/traerParkingsMunicipio`, {
      idMunicipio: this.fsession.optenerValor("dato4"),
    });
  }

  traerGraficosParking(idParking, tipo, fecha, titulo, fechaFin = null) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosParking`, {
      idParking,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }
  traerGraficosParkingV2(idParking, tipo, fecha, titulo, fechaFin = null) {
    var idioma = this.fsession._currentLang.value;
    return this.http.post(`${this.baseUrl}/traerGraficosParkingV2`, {
      idParking,
      tipo,
      fecha,
      idioma,
      titulo,
      fechaFin,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41"),
    });
  }
  /**
   * Obtiene el último registro de metadatos de una cámara
   * @param id_camara Id de cámara
   * @returns Observable
   */
  getCameraMetadata(
    id_camara: string
  ): Observable<any[]> {

    const data = { id_camara };
    return this.http.post<any>(`${this.baseUrl}/getCameraMetadata`, data);

  }

  /**
   * Obtiene el último registro de metadatos de una cámara
   * @param id_camara Id de cámara
   * @returns Observable
   */
  TraerCamarasMetadato(): Observable<any[]> {
    return this.http.get<any>(`${this.baseUrl}/TraerCamarasMetadato`);
  }

  downloadPhotosBackground(data) {
    let Fechalimite = new Date();
    Fechalimite.setDate(Fechalimite.getDate() + 7);
    return this.http.post(`${this.baseUrl}/AgregarDescargaPendienteFotos`, {
      data,
      Fechalimite,
    });
  }

  getTramosByMunicipio(idMunicipio) {
    const data = { idMunicipio: idMunicipio }
    return this.http.post<any>(`${this.baseUrl}/getTramosByMunicipio`, data);
  }

  getColorsByIdioma(idioma): Observable<ColorByLanguage[]> {
    const data = { idioma: idioma }
    return this.http.post<any>(`${this.baseUrl}/getColorsByIdioma`, data);
  }

  /**
   * Crear o actualiza la configuracion del usuario por municipio
   * @param data datos para crear o actualizar
   * @returns Observable
   */
  createOrUpdateMunicipalityConfigurationByUser(data: Omit<MunicipalityConfigurationByUser, "fecha_alta">): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/createOrUpdateMunicipalityConfigurationByUser`, data);
  }

  /**
   * Crear o actualiza la configuracion del usuario por municipio
   * @param data datos para crear o actualizar
   * @returns Observable
   */
  UpdateNoplateMunicipalityByUser(data): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/UpdateNoplateMunicipalityByUser`, data);
  }

  /**
   * Obtiene la configuracion de determinado municipio por usuario
   * @param idUser id de usuario
   * @param idMunicipality id de municipio
   * @returns Observable
   */
  getMunicipalityConfigurationsByUser(idUser: string, idMunicipality: string): Observable<MunicipalityConfigurationByUser[]> {
    return this.http.get<MunicipalityConfigurationByUser[]>(`${this.baseUrl}/getMunicipalityConfigurationsByUser/${idUser}/${idMunicipality}`);
  }

  /**
   * Obtiene la configuracion de determinado municipio por usuario
   * @param idUser id de usuario
   * @param idMunicipality id de municipio
   * @returns Observable
   */
  getAllMunicipalityConfigurationsByUser(idUser: string, idMunicipality: string): Observable<MunicipalityConfigurationByUser[]> {
    return this.http.get<MunicipalityConfigurationByUser[]>(`${this.baseUrl}/getAllMunicipalityConfigurationsByUser/${idUser}/${idMunicipality}`);
  }

  exportUserToB2C(user: Usuario) {
    return this.http.post(`${this.baseUrl}/exportUserToB2C`, user)
  }

  VerificarUsuarioB2C(usuario, mail) {
    const data = {
      Usuario: usuario,
      Mail: mail
    };

    return this.http.post(`${this.baseUrl}/verifyIfUserExistInB2C`, data);
  }

  /**
   * Guardar un nuevo color
   * @param color color a guardar
   * @returns Observable
   */
  saveColor(color: Omit<Color, 'id'>): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/saveColor`, { color });
  }

  /**
   * Modifica un color
   * @param color color a modificar
   * @returns Observable
   */
  modifyColor(color: Color): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/modifyColor`, { color });
  }

  /**
   * Obtiene informacion de la tabla "paisVehiculos"
   * @returns Observable
   */
  getCountryVehicles(): Observable<VehicleCountry[]> {
    return this.http.get<VehicleCountry[]>(`${this.baseUrl}/getCountryVehicles`);
  }

  /**
   * Guardar un nuevo color
   * @param color color a guardar
   * @returns Observable
   */
  saveVehicleCountry(vehicleCountry: Omit<VehicleCountry, 'id_pais'>): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/saveVehicleCountry`, { vehicleCountry });
  }

  /**
   * Modifica un registro en la tabla "paisVehiculos"
   * @param vehicleCountry registro a modificar
   * @returns Observable
   */
  modifyVehicleCountry(vehicleCountry: VehicleCountry): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/modifyVehicleCountry`, { vehicleCountry });
  }

  /**
   * Obtiene informacion de la tabla "deteccionVehiculos"
   * @returns Observable
   */
  getVehiclesDetection(): Observable<VehicleDetection[]> {
    return this.http.get<VehicleDetection[]>(`${this.baseUrl}/getVehiclesDetection`);
  }

  /**
   * Guardar nuevo registro en la tabla "deteccionVehiculos"
   * @param vehicleDetection registro a guardar
   * @returns Observable
   */
  saveVehicleDetection(vehicleDetection: Omit<VehicleDetection, 'id_deteccion'>): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/saveVehicleDetection`, { vehicleDetection });
  }

  /**
   * Modifica un registro en la tabla "deteccionVehiculos"
   * @param vehicleDetection registro a modificar
   * @returns Observable
   */
  modifyVehicleDetection(vehicleDetection: VehicleDetection): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/modifyVehicleDetection`, { vehicleDetection });
  }

  /**
   * Guardar nuevo registro en la tabla "marcas"
   * @param brand registro a guardar
   * @returns Observable
   */
  saveBrand(brand: Omit<Brand, 'id'>): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/saveBrand`, { brand });
  }

  /**
   * Modifica un registro en la tabla "marcas"
   * @param brand registro a modificar
   * @returns Observable
   */
  modifyBrand(brand: Brand): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/modifyBrand`, { brand });
  }

  /**
   * Trae los detalles de un release en Github
   * @param brand registro a modificar
   * @returns Observable
   */
  getLatestRelease(version): Observable<any> {
    return this.http.get(`${this.baseUrl}/getLatestRelease/${version}`);
  }

  /**
   * Trae el listado de la plataforma
   * @param brand registro a modificar
   * @returns Observable
   */
  getVersionHistory(): Observable<any> {
    return this.http.get(`${this.baseUrl}/getVersionHistory`);
  }

  /**
   * Seleccionar parkings segun el municipio
   * @param municipio municipio
   * @returns Observable
   */
  getInfoParkings(municipio: number, pageIndex: number, pageSize: number, sort: any): Observable<Parking[]> {
    const data = { municipio, pageIndex, pageSize, sort };
    return this.http.post<any>(`${this.baseUrl}/getInfoParkings`, data);
  }

  /**
   * Actualizar los datos de un parking
   * @param Infodata info del parking
   * @returns Observable
   */
  UpdateParking(Infodata: any): Observable<any[]> {
    const data = { Infodata: Infodata };
    return this.http.post<any>(`${this.baseUrl}/UpdateParking`, data);
  }

  /**
   * Crear un nuevo parking y asignar múltiples cámaras
   * @param Infodata info del parking
   * @param camaras Lista de cámaras con id y entrada_adelante
   * @returns Observable
   */
  createParking(Infodata: any, camaras: any): Observable<any[]> {
    const data = { Infodata: Infodata, camaras: camaras };
    return this.http.post<any>(`${this.baseUrl}/createParking`, data);
  }

  /**
   * Actualizar cámaras según el parking
   * @param Infodata info del parking
   * @param camaras Lista de cámaras con id y entrada_adelante
   * @returns Observable
   */
  UpdateCamarasPorParking(Infodata: any, camaras: any): Observable<any[]> {
    const data = { Infodata: Infodata, camaras: camaras };
    return this.http.post<any>(`${this.baseUrl}/UpdateCamarasPorParking`, data);
  }

  /**
   * Obtener parkings segun el id_parking
   * @param id_parking id_parking
   * @returns Observable
   */
  getCamarasPorParking(id_parking: number): Observable<any[]> {
    const data = { id_parking };
    return this.http.post<any>(`${this.baseUrl}/getCamarasPorParking`, data);
  }

  /**
   * Obtener regularaciones del parking
   * @param id_parking id_parking
   * @returns Observable
   */
  getRegularizacionesPorParking(id_parking: number): Observable<any[]> {
    const data = { id_parking };
    return this.http.post<any>(`${this.baseUrl}/getRegularizacionesPorParking`, data);
  }

  /**
  * Insertar regularización en el parking
  * @param Infodata info de la regularizacion
  * @returns Observable
  */
  insertRegularizacion(Infodata: Regularizacion): Observable<Regularizacion[]> {
    const data = { Infodata: Infodata };
    return this.http.post<any>(`${this.baseUrl}/insertRegularizacion`, data);
  }

  /**
  * Insertar cámaras en la tabla parking_cam
  * @param Infodata info de las camaras
  * @param id_parking id_parking
  * @returns Observable
  */
  insertCameraParking(id_parking: number, Infodata: InfoCamerasParking[]): Observable<InfoCamerasParking[]> {
    const data = { id_parking: id_parking, Infodata: Infodata };
    return this.http.post<any>(`${this.baseUrl}/insertCameraParking`, data);
  }

  /**
   * Obtiene datos del tráfico de peatones
   * @param idMunicipio idMunicipio
   * @param tipo number
   * @param fecha fecha del evento
   * @param origen origen de datos puede ser wifi, linea de detección y metadatos (futuro)
   * @returns Observab con la informacion
   */
  getPedestrianTrafficInMap(idMunicipio: number, tipo: number, fecha: string, origen: number): Observable<TrafficPedestrian[]> {
    const data = { idMunicipio, tipo, fecha, origen };
    return this.http.post<TrafficPedestrian[]>(`${this.baseUrl}/getPedestrianTrafficInMap`, data);
  }

  /**
   * Obtiene los municipios asignados
   * @param idUsuario id del usuario
   * @returns Observable
   */
  getAssignedMunicipalities(idUsuario: any): Observable<any> {
    const data = { idUsuario };
    return this.http.post<any>(`${this.baseUrl}/getAssignedMunicipalities`, data);
  }
  /**
   * 
   * Traduce un texto a varios idiomas utilizando la API de Lingva
   * @param idioma Idioma original del texto
   * @param texto Texto a traducir
   * @param idiomasTraducidos Lista de idiomas a los que se traducirá el texto. Si no se proporciona, se traducirá a español, catalán, francés e inglés.
   * @returns Un objeto con las traducciones del texto a los idiomas especificados.
   */
  async traducir(idioma: string, texto: string = '', idiomasTraducidos: string[] = []): Promise<{ [lang: string]: string }> {
    const apiUrlTraduccion = 'https://lingva.ml/api/v1/';

    const idiomas = idiomasTraducidos.length > 0 ? idiomasTraducidos : ['es', 'ca', 'fr', 'en', 'pv'];
    const targetLangs = idiomas.filter(lang => lang !== idioma);

    const requests = targetLangs.map(async (lang) => {
      // Reemplazar 'va' por 'ca' y 'pv' por 'eu'
      const fromLang = lang === 'va' ? 'ca' : (lang === 'pv' ? 'eu' : lang);
      const url = `${apiUrlTraduccion}${idioma}/${fromLang}/${encodeURIComponent(texto)}`;

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Error al traducir a ${fromLang}: ${response.statusText}`);
      }

      const data = await response.json();
      return { lang, translation: data.translation }; // Mantén la clave original 'pv' si eso quieres como resultado
    });

    const results = await Promise.all(requests);
    const traducciones: { [lang: string]: string } = {};
    results.forEach(res => {
      traducciones[res.lang] = res.translation;
    });

    return traducciones;
  }

  /**
   * Obtiene variables de traduccion en formato JSON de determinado idioma
   * @param language idioma
   * @returns Observable
   */
  getTranslations(language: SupportedLanguages): Observable<{ [key: string]: string }> {
    return this.http.get<any>(`${configuracion.translations_URL}${language}.json?v=${Date.now()}`);
  }

  /**
   * Sube al storage determinado archivo de traducción
   * @param formData archivo a subir
   * @returns Observable
   */
  uploadTranslationFile(formData: FormData): Observable<{ ok: boolean, message: string }> {
    return this.http.post<{ ok: boolean, message: string }>(`${this.baseUrl}/translation/uploadTranslationFile`, formData);
  }

  /**
   * Obtiene la configuracion del panel de turismo por municipio
   * @param idMunicipio id municipio
   * @returns Observable
   */
  getTourismPanelConfigurationByMunicipality(idMunicipio: number): Observable<ConfigurationTourismPanel[]> {
    return this.http.get<ConfigurationTourismPanel[]>(`${this.baseUrl}/getTourismPanelConfigurationByMunicipality/${idMunicipio}`);
  }

  /**
   * Guarda o modifica configuracion del panel de turismo por municipio
   * @param data datos de la configuracion
   * @param groupCameras grupos de camaras (accesos - opcional)
   * @returns Observable
   */
  saveOrModifyTourismPanelConfigurationByMunicipality(
    data: OmitDataInConfigurationTourismPanel,
    groupCameras: GroupCamerasInConfigurationTourismPanel[] = []
  ): Observable<any> {
    const body = { ...data, groupCameras };
    return this.http.post<any>(`${this.baseUrl}/saveOrModifyTourismPanelConfigurationByMunicipality`, body);
  }

  /**
   * Establece datos de ejecucion en la configuracion del panel de turismo por municipio
   * @param id_municipio id municipio
   * @param id_configuracion_panel_turismo id de registro
   * @returns Observable
   */
  setExecutionDataInTourismPanelConfiguration(id_municipio: number, id_configuracion_panel_turismo: number): Observable<any> {
    const data = { id_municipio, id_configuracion_panel_turismo };
    return this.http.post<any>(`${this.baseUrl}/setExecutionDataInTourismPanelConfiguration`, data);
  }

  /**
   * Obtiene cámaras de peatones por municipio
   * @param id_municipio id municipio
   * @param [onlyAsigned=false] Si solo se traen las cámaras que tengan definida la variable de zona
   * @returns Observable
   */
  getPedestrianCamerasByMunicipality(idMunicipio: number, onlyAsigned: boolean = false): Observable<PedestrianZone[]> {
    return this.http.get<PedestrianZone[]>(`${this.baseUrl}/getPedestrianCamerasByMunicipality/${idMunicipio}/${onlyAsigned}`);
  }

  /**
   * Crear nueva zona 
   * @param name nombre de la zona
   * @param ids_cameras id (registro en base de datos) de las camaras seleccionadas
   * @returns Observable
   */
  createZone(name: string, ids_cameras: number[]): Observable<{ ok: boolean, message: string }> {
    const data = { name, ids_cameras };
    return this.http.post<any>(`${this.baseUrl}/createZone`, data);
  }

  /**
   * Crear nueva zona 
   * @param name nombre de la zona
   * @param ids_cameras id (registro en base de datos) de las camaras seleccionadas
   * @returns Observable
   */
  createZoneGroup(name: string, ids_cameras: number[]): Observable<{ ok: boolean, message: string }> {
    const data = { name, ids_cameras };
    return this.http.post<any>(`${this.baseUrl}/createZoneGroup`, data);
  }

  /**
   * Crear nueva zona 
   * @param name nombre de la zona
   * @param ids_cameras id (registro en base de datos) de las camaras seleccionadas
   * @returns Observable
   */
  setZoneCoefficient(coefficient: number, id_camera: number): Observable<{ ok: boolean, message: string }> {
    const data = { coefficient, id_camera };
    return this.http.post<any>(`${this.baseUrl}/setZoneCoefficient`, data);
  }

  /**
   * Obtiene los registros de la tabla controlbarrera filtrados por el IdMunicipio con ordenamiento.
   * @param idMunicipio Id del municipio
   * @param sort Campo por el que se ordena
   * @returns Observable
   * @param activo Estado del filtro activo
   */
  getControlBarrierByMunicipality(idMunicipio: number, activo: boolean, sort: any): Observable<ConfiguracionParking[]> {
    const data = { idMunicipio, activo, sort }
    return this.http.post<any>(`${this.baseUrl}/getControlBarrierByMunicipality`, data);
  }

  /**
   * Obtiene los registros de la tabla controlbarrera filtrados por el idrouter
   * @param idrouter Id del router
   * @param activo Estado del filtro activo
   * @returns Observable
   */
  getControlBarrierByRouter(idrouter: number, activo: boolean): Observable<ConfiguracionParking[]> {
    const data = { idrouter, activo }
    return this.http.post<any>(`${this.baseUrl}/getControlBarrierByRouter`, data);
  }

  /**
   * Crea un nuevo registro en la tabla controlbarrera.
   * @param controlBarrierData Datos para crear un nuevo registro en controlbarrera
   * @returns Observable
   */
  createControlBarrier(controlBarrierData: ConfiguracionParking): Observable<ConfiguracionParking> {
    return this.http.post<any>(`${this.baseUrl}/createControlBarrier`, controlBarrierData);
  }

  /**
   * Actualiza un registro en la tabla controlbarrera.
   * @param idrouter Id del router a actualizar
   * @param campos Campos a actualizar en el registro
   * @returns Observable
   */
  updateControlBarrier(idrouter: number, campos: ConfiguracionParking): Observable<ConfiguracionParking> {
    const data = { idrouter, ...campos };
    return this.http.post<any>(`${this.baseUrl}/updateControlBarrier`, data);
  }

  /**
   * Obtiene la lista de interes filtrada por id lista
   * @param idlista id de la lista de interes
   * @param idMunicipality id de municipio
   * @returns Observable
   */
  getListsInterestById(idlista: number, idMunicipality: number): Observable<ConfiguracionParking[]> {
    return this.http.get<any[]>(`${this.baseUrl}/getListsInterestById/${idlista}/${idMunicipality}`);
  }

  /**
   * Obtiene tickets
   * @param id_municipio arreglo de ids de municipios
   * @param estado estado del ticket
   * @param busqueda parametro de busqueda
   * @returns Observable
   */
  getTickets(
    ids_municipios: number[],
    estado: EnumStateTicket | 'all',
    busqueda: string
  ): Observable<Ticket[]> {
    const data: {
      ids_municipios: number[],
      estado?: EnumStateTicket,
      busqueda?: string
    } = { ids_municipios };
    if (estado !== 'all') data.estado = estado;
    if (busqueda) data.busqueda = busqueda;
    return this.http.post<Ticket[]>(`${this.baseUrl}/getTickets`, data);
  }

  getCausasTickets(
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}/getCausasTickets`, {});
  }

  getTipoIncidencias(
  ): Observable<Array<{ IdTipo: number; Nombre: string }>> {
    return this.http.get<Array<{ IdTipo: number; Nombre: string }>>(`${this.baseUrl}/getTipoIncidencias`);
  }

  getTiposTicket(
  ): Observable<Array<{ id: number; nombre: string }>> {
    return this.http.get<Array<{ id: number; nombre: string }>>(`${this.baseUrl}/getTipoTickets`);
  }

  getSolucionesTickets(
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}/getSolucionesTickets`, {});
  }

  resolverTicket(data
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}/resolverTicket`, { data });
  }

  /**
   * Obtiene usuarios por uno o mas municipios
   * @param ids_municipios arreglo de ids de municipios
   * @returns Observable
   */
  getUsersByMunicipalities(ids_municipios: number[]): Observable<Pick<Usuario, 'IdUsuario' | 'Nombre'>[]> {
    const data = { ids_municipios };
    return this.http.post<Pick<Usuario, 'IdUsuario' | 'Nombre'>[]>(`${this.baseUrl}/getUsersByMunicipalities`, data);
  }

  /**
   * Guarda un nuevo ticket
   * @param ticket informacion de ticket a guardar
   * @returns Observable
   */
  createTicket(ticket: FormData): Observable<{ ok: boolean, message: string }> {
    return this.http.post<{ ok: boolean, message: string }>(`${this.baseUrl}/createTicket`, ticket);
  }

  /**
   * Edita un ticket
   * @param ticket informacion de ticket a modificar
   * @returns Observable
   */
  editTicket(ticket: FormData): Observable<{ ok: boolean, message: string }> {
    return this.http.put<{ ok: boolean, message: string }>(`${this.baseUrl}/editTicket`, ticket);
  }

  /**
   * Obtiene el archivo de un ticket
   * @param data contiene los campos id_usuario, id_ticket y archivo de un ticket
   * @returns un observable que devuelve si se obtuvo el archivo correctamente y el archivo como string
   */
  getFileOfTicket(data: Pick<Ticket, 'id_usuario' | 'id_ticket' | 'archivo'>): Observable<{ ok: boolean, file: string }> {
    return this.http.post<{ ok: boolean, file: string }>(`${this.baseUrl}/getFileOfTicket`, data);
  }

  getTicketsColumnConfiguration(): Observable<{ configuracion: string | null }> {
    return this.http.get<{ configuracion: string | null }>(
      `${this.baseUrl}/getTicketsColumnConfiguration`
    );
  }

  saveTicketsColumnConfiguration(configuracion: object): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/saveTicketsColumnConfiguration`, {
      configuracion
    });
  }

  bulkUpdateTicketsEstado(body: { id_tickets: number[]; estado: string }): Observable<{ ok: boolean; updated?: number }> {
    return this.http.put<{ ok: boolean; updated?: number }>(
      `${this.baseUrl}/bulkUpdateTicketsEstado`,
      body
    );
  }

  /**
   * Envía datos de control para la barrera al backend.
   * @param data Objeto que contiene los datos necesarios para el control de la barrera.
   * @returns Observable con la respuesta del backend
   */
  sendDataControlBarrera(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/sendDataControlBarrera`, data);
  }

  /**
 * Envía datos de la lista de interes para agregar esa lista a una camara
 * @param data Objeto que contiene los datos de la camara y lista
 * @returns Observable con la respuesta del backend
 */
  sendMessageBlackListCameras(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/sendMessageBlackListCameras`, data);
  }

  /**
 * Envia datos para calibrar un FotoRojo por medio de un comando de ServiceBus.
 * @param data Objeto que contiene los datos necesarios para el control de la barrera.
 * @returns Observable con la respuesta del backend
 */
  sendDataCalibrateFotoRojo(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/sendDataCalibrateFotoRojo`, data);
  }

  /**
   * Actualizar regularización del parking
   * @param datosAnteriores Datos antes de editar
   * @param datosEditados Datos ya editados
   * @returns Observable
   */
  updateRegularizacion(datosAnteriores: Regularizacion, datosEditados: Regularizacion): Observable<any> {
    const data = { datosAnteriores, datosEditados };
    return this.http.post<any>(`${this.baseUrl}/updateRegularizacion`, data);
  }

  /**
   * Borrar regularización del parking
   * @param datosAnteriores Datos que se borraran
   * @returns Observable
   */
  deleteRegularizacion(datosAnteriores: Regularizacion): Observable<any> {
    const data = { datosAnteriores };
    return this.http.post<any>(`${this.baseUrl}/deleteRegularizacion`, data);
  }

  /**
   * Obtiene los grupos de camaras relacionados con una configuración del panel de turismo
   * @param id_configuracion_panel_turismo id de configuración del panel de turismo
   * @returns Observable
   */
  getGroupsOfCamerasByTourismPanelConfiguration(id_configuracion_panel_turismo: number): Observable<GroupCamerasInConfigurationTourismPanel[]> {
    return this.http.get<any>(`${this.baseUrl}/getGroupsOfCamerasByTourismPanelConfiguration/${id_configuracion_panel_turismo}`);
  }

  /**
   * Agrega un nuevo grupo de camaras a una configuracion de panel de turismo por municipio
   * @param data datos de grupo a guardar
   * @returns Observable
   */
  addNewGroupsOfCamerasByTourismPanelConfiguration(
    data: Omit<GroupCamerasInConfigurationTourismPanel, 'nombre_camara_entrada' | 'nombre_camara_salida'>
  ): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/addNewGroupsOfCamerasByTourismPanelConfiguration`, data);
  }

  /**
   * Edita un grupo de camaras ya existente en una configuracion de panel de turismo por municipio
   * @param data datos del grupo de camaras a editar sin incluir nombre_camara_entrada y nombre_camara_salida
   * @returns Observable con un objeto que contiene un booleano "ok" que es true si la edición fue exitosa
   */
  editNewGroupsOfCamerasByTourismPanelConfiguration(
    data: Omit<GroupCamerasInConfigurationTourismPanel, 'nombre_camara_entrada' | 'nombre_camara_salida'>
  ): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/editNewGroupsOfCamerasByTourismPanelConfiguration`, data);
  }

  /**
   * Elimina un grupo de camaras de una configuracion de panel de turismo por municipio
   * @param data datos a verificar para eliminar
   * @returns Observable
   */
  removeGroupOfCamerasByTourismPanelConfiguration(
    data: Omit<GroupCamerasInConfigurationTourismPanel, 'nombre_camara_entrada' | 'nombre_camara_salida'>
  ): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/removeGroupOfCamerasByTourismPanelConfiguration`, data);
  }

  /**
   * Obtiene informacion de las camaras de matricula y ubicacion de soporte por municipio
   * @param idMunicipality id de municipio
   * @returns Observable
   */
  getLicensePlateCameraInformationAndSupportLocation(idMunicipality: number): Observable<InfoCameraAndSupportLocation[]> {
    return this.http.get<InfoCameraAndSupportLocation[]>(
      `${this.baseUrl}/getLicensePlateCameraInformationAndSupportLocation/${idMunicipality}`
    );
  }

  /**
   * Exporta los datos procesados del panel de turismo por municipio
   * @param acceso Número del Acceso
   * @param tipo 1 - Dia, 2 - Semana, 3 - Mes, 4 - Año, 5 - Acumulado, 6 - Personalizado
   * @param fecha Fecha de inicio de la consulta
   * @param fechaFin Fecha de fin de la consulta
   * @returns Observable
   */
  exportProcessedTourismPanelData(
    acceso: number,
    tipo: number,
    fecha: string,
    fechaFin: string = null): Observable<{ data: processedTourismPanelData[] }> {

    const data = {
      idioma: this.fsession._currentLang.value,
      acceso,
      fecha,
      tipo,
      fechaFin,
      idMunicipio: this.fsession.optenerValor("dato4"),
      zonaHoraria: this.fsession.optenerValor("dato41")
    }
    return this.http.post<{ data: processedTourismPanelData[] }>(`${this.baseUrl}/exportProcessedTourismPanelData`, data)

  }

  /**
   * Env a un correo electronico con las credenciales de un usuario
   * @param email correo electronico del usuario
   * @param usuario nombre del usuario
   * @param password contrase a del usuario
   * @param nameRol nombre del rol que se le asigna al usuario
   * @returns Observable con la respuesta del servidor, que contiene un booleano que indica si se envio el correo con exito y un mensaje adicional
   */
  sendEmailWithCredentialsUser(
    email: string,
    usuario: string,
    password: string,
    nameRol: string,
    emailTemplate?: string
  ): Observable<{ ok: boolean; message: string; code?: string }> {
    const data = { email, usuario, password, nameRol, emailTemplate };
    return this.http.post<{ ok: boolean; message: string; code?: string }>(`${this.baseUrl}/sendEmailWithCredentialsUser`, data);
  }

  /**
  * Actualiza el campo terminoEns de un usuario
  * @param terminoEns Valor booleano de terminoEns
  * @returns Observable
  */
  updateTerminoEnsUsuario(terminoEns: boolean): Observable<any> {
    const data = { terminoEns };
    return this.http.post(`${this.baseUrl}/updateTerminoEnsUsuario`, data);
  }

  /**
   * Obtiene el valor de terminoEns de un usuario
   * @returns Observable con el valor de terminoEns
   */
  getTerminoEnsUsuario(): Observable<any> {
    return this.http.get(`${this.baseUrl}/getTerminoEnsUsuario`);
  }

  /**
   * Verifica si existe el nombre de un acceso en una configuracion del panel de turismo
   * @param nombre nombre del acceso a verificar
   * @param id_configuracion_panel_turismo id de la configuracion del panel de turismo a verificar
   * @returns Observable
   */
  existAccessNameByTourismPanelConfiguration(
    nombre: string,
    id_configuracion_panel_turismo: number
  ): Observable<{ exist: boolean, id_grupo_camara: number }[]> {
    const data = { nombre, id_configuracion_panel_turismo };
    return this.http.post<any>(`${this.baseUrl}/existAccessNameByTourismPanelConfiguration`, data);
  }

  /**
   * Envía datos filtrados para obtener tráfico de peatones
   * @param fecha Fecha del evento
   * @param municipio ID del municipio
   * @param zonaHoraria Zona horaria del municipio
   * @param idCamara ID de la cámara
   * @returns Observable con la información procesada
   */
  getFilteredPedestrianData(fecha: string, idCamara: number): Observable<any[]> {
    const idMunicipio = this.fsession.optenerValor("dato4");
    const zonaHoraria = this.fsession.optenerValor("dato41");

    const data = { fecha, idMunicipio, zonaHoraria, idCamara };
    return this.http.post<any[]>(`${this.baseUrl}/getFilteredPedestrianData`, data);
  }

  /**
   * Obtiene el seguimiento (tracking) de los routers en un municipio
   * @param idMunicipality id del municipio
   * @returns Observable
   */
  getTrackingByMunicipality(idMunicipality: number): Observable<Tracking[]> {
    return this.http.get<Tracking[]>(`${this.baseUrl}/getTrackingByMunicipality/${idMunicipality}`);
  }

  /**
   * Obtiene el seguimiento de un router en un rango de fechas
   * @param idRouter El ID del router del cual se desea obtener el seguimiento
   * @param dateInit La fecha de inicio del rango de seguimiento
   * @param dateEnd La fecha final del rango de seguimiento
   * @param range El rango de tiempo (en minutos) del rango de seguimiento
   * @returns Observable
   */
  getTrackingByRouter(idrouter: number, dateInit: string, dateEnd: string, range: number): Observable<Omit<Tracking, 'routerName'>[]> {
    const data = {
      idrouter,
      dateInit,
      dateEnd,
      range
    }
    return this.http.post<any>(`${this.baseUrl}/getTrackingByRouter`, data);
  }

  /**
   * Agrega un punto de inters en el mapa
   * @param interestPoint datos del punto de interes sin incluir el idPuntoInteres
   * @returns Observable
   */
  addPointOfInterestOnMap(interestPoint: Omit<InterestPoint, 'idPuntoInteres'>): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/addPointOfInterestOnMap`, interestPoint);
  }

  /**
   * Obtiene los puntos de interes en el mapa de un municipio
   * @param idMunicipality El ID del municipio del cual se desean obtener los puntos de inter s
   * @returns Observable con los puntos de interes
   */
  getPointOfInterestOnMapByMunicipality(idMunicipality: number): Observable<InterestPoint[]> {
    return this.http.get<InterestPoint[]>(`${this.baseUrl}/getPointOfInterestOnMapByMunicipality/${idMunicipality}`);
  }

  /**
   * Elimina uno o varios puntos de interes en el mapa.
   * @param idsInterestPoint Un arreglo con los id de los puntos de interes a eliminar
   * @returns Observable
   */
  deletePointOfInterest(idsInterestPoint: number[]): Observable<{ ok: boolean }> {
    const data = { idsInterestPoint }
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/deletePointOfInterest`, data);
  }

  /**
   * Actualiza un punto de interés en la base de datos.
   * 
   * @param interestPoint Los datos del punto de interés a actualizar
   * @returns Observable
   */
  updatePointOfInterest(interestPoint: InterestPoint): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/updatePointOfInterest`, interestPoint);
  }

  /**
   * Obtener
   * @param idMunicipio ID del municipio
   * @returns Observable con la información procesada
   */
  getdataCamerasSentilo(): Observable<any[]> {
    const idMunicipality = this.fsession.optenerValor("dato4");
    return this.http.get<any[]>(`${this.baseUrl}/getdataCamerasSentilo/${idMunicipality}`);
  }

  /**
   * Modificar información de cámaras con Sentilo
   * @param idCamara ID de la cámara a modificar
   * @param datos Datos a modificar
   * @returns Observable
   */
  modificarDatosCamerasSentilo(idCamara: number, datos: any): Observable<any[]> {
    const data = { idCamara, datos };
    return this.http.post<any[]>(`${this.baseUrl}/modificarDatosCamerasSentilo`, data);
  }

  /**
   * Obtener las categorías de seguimiento por id de municipio
   * @param idMunicipality ID del municipio
   * @returns Observable con las categorías de seguimiento
   */
  getCategoriesByMunicipality(idMunicipality: number): Observable<TrackingCategory[]> {
    return this.http.get<TrackingCategory[]>(`${this.baseUrl}/getCategoriesByMunicipality/${idMunicipality}`);
  }
  getDataDGT(id_datos_DGT?: number): Observable<any[]> {
    if (id_datos_DGT) {
      return this.http.get<any[]>(`${this.baseUrl}/getDataDGT/${id_datos_DGT}`);
    }
    return this.http.get<any[]>(`${this.baseUrl}/getDataDGT`);
  }
  getDistintivoMedioambiental
    (): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/getDistintivoMedioambiental`);
  }
  /**
   * Agrega una categoría de seguimiento para un municipio
   * @param category La categoría de seguimiento a agregar, sin incluir el idCategoria
   * @returns Observable
   */
  saveCategoryByMunicipality(category: Omit<TrackingCategory, 'idCategoria'>): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/saveCategoryByMunicipality`, category);
  }

  /**
   * Guarda nueva información DGT
   * @param data - información a guardar
   * @returns 
   */
  saveNewDGT(data: any) {
    return this.http.post(`${this.baseUrl}/saveNewDGT`, data);
  }

  /**
   * Modifica información DGT
   * @param data - información a modificar
   * @returns
   */
  modifyDataDGT(data: any) {
    return this.http.post(`${this.baseUrl}/modifyDataDGT`, data);
  }

  /**
   * Guarda nueva información ZAR DGT
   * @param data - información a guardar
   * @returns
   */
  saveNewZarDataDGT(data: any) {
    return this.http.post(`${this.baseUrl}/saveNewZarDataDGT`, data);
  }

  /**
   * Modifica información ZAR DGT
   * @param data - información a modificar
   * @returns 
   */
  modifyZarDataDGT(data: any) {
    return this.http.post(`${this.baseUrl}/modifyZarDataDGT`, data);
  }
  /**
   * Modifica una categoría de seguimiento para un municipio
   * @param category La categoría de seguimiento a modificar, sin incluir el idMunicipio
   * @returns Observable con resultado de la operación
   */
  modifyCategoryByMunicipality(category: Omit<TrackingCategory, 'idMunicipio'>): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/modifyCategoryByMunicipality`, category);
  }

  /**
   * Modificar información de cámaras con Sentilo
   * @param idCamara ID de la cámara a modificar
   * @returns Observable
   */

  resetearDatosCamerasSentilo(idCamara: number): Observable<any[]> {
    const data = { idCamara };
    return this.http.post<any[]>(`${this.baseUrl}/resetearDatosCamerasSentilo`, data);
  }

  /**
   * Actualiza la API de un vehículo
   * @param id ID del vehículo a actualizar
   * @param api Nombre API
   * @param apiUrl URL de la API
   * @param apiPeriodicity periodicidad de la API
   * @returns Observable con el resultado de la actualización
   */
  updateListVehicleApi(id: number, api: string, apiUrl: string, apiPeriodicity: number): Observable<{ ok: boolean, message: string }> {
    const data = { id, api, apiUrl, apiPeriodicity };
    return this.http.post<{ ok: boolean, message: string }>(`${this.baseUrl}/updateListVehicleApi`, data);
  }

  /**
   * Traer soportes clima
   * @param activado bandera
   * @param IdMunicipio id de municipio
   * @param callback Callback de la función
   */
  traerSoportesCLima(activado, IdMunicipio) {
    const data = {
      activado: activado,
      IdMunicipio: IdMunicipio,
    };
    return this.http.post(`${this.baseUrl}/traerSoportesCLima`, data);
  }

  /**
   * Actualiza los campos credencialesApi y esquemaJsonApi en la tabla ListaVehiculos
   * @param idLista ID de la lista de vehículos a actualizar
   * @param credencialesApi Credenciales API
   * @param esquemaJsonApi Esquema JSON
   * @returns Observable
   */
  actualizarCredencialesListaVehiculos(idLista: number, credencialesApi: string, esquemaJsonApi: string) {
    const data = {
      idLista,
      credencialesApi,
      esquemaJsonApi
    };

    return this.http.post(`${this.baseUrl}/actualizarCredencialesListaVehiculos`, data);
  }

  /**
   * Obtiene el inventario de trackings (router con tracking activado) por municipio
   * @param idMunicipality id del municipio
   * @returns Observable
   */
  getInventoryTrackingByMunicipality(idMunicipality: number): Observable<InventoryTracking[]> {
    return this.http.get<InventoryTracking[]>(`${this.baseUrl}/getInventoryTrackingByMunicipality/${idMunicipality}`);
  }

  /**
   * Obtiene los routers de un municipio que tienen el tracking deshabilitado.
   * @param idMunicipality ID del municipio
   * @returns Observable
   */
  getRouterByMunicipalityByTrackingDisabled(idMunicipality: number): Observable<RouterTrackingDisabled[]> {
    return this.http.get<RouterTrackingDisabled[]>(`${this.baseUrl}/getRouterByMunicipalityByTrackingDisabled/${idMunicipality}`);
  }

  /**
   * Modifica un router relacionado con el inventario de trackings
   * @param data Objeto que contiene los datos del router
   * @returns Observable
   */
  modifyInventoryTrackingRouter(data: RouterTrackingDisabled): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/modifyInventoryTrackingRouter`, data);
  }

  /**
   * Obtiene los registros de la tabla Registros_VehiculosDB_Camara_Inactiva
   * @returns Observable
   */
  obtenerRegistrosCamaraInactiva() {
    return this.http.get(`${this.baseUrl}/obtenerRegistrosCamaraInactiva`);
  }

  /**
   * Obtiene los registros de la tabla Registros_VehiculosDB_Huerfanos_UltimaSemana
   * @returns Observable
   */
  obtenerRegistrosHuerfanosUltimaSemana() {
    return this.http.get(`${this.baseUrl}/obtenerRegistrosHuerfanosUltimaSemana`);
  }

  /**
   * Filtra los datos por id de eventoscam y obtener imagenes
   * @param ids IDs de los registros separados por comas
   * @returns
   */
  cameraImageRecordsById(ids) {
    const data = { ids };
    return this.http.post(`${this.baseUrl}/cameraImageRecordsById`, data);
  }

  /**
   * Verifica si un router activo ya está registrado con un campo específico (IP o SSID)
   * @param column Nombre del campo a verificar (ej. 'ip' o 'SSID')
   * @param value Valor del campo a verificar
   * @param routerId (Opcional) ID del router actual para excluirlo de la búsqueda
   * @returns Observable con la respuesta del servidor
   */
  routerFieldExists(column: string, value: string, routerId: number | null = null): Observable<{ exists: boolean; data?: any | null }> {
    const data = { column, value, routerId };
    return this.http.post<{ exists: boolean; router?: any }>(`${this.baseUrl}/routerFieldExists`, data);
  }

  /**
   * Verifica si una camera activa ya está registrado con un campo específico (ip o id_camara)
   * @param column Nombre del campo a verificar (ej. 'ip' o 'id_camara')
   * @param value Valor del campo a verificar
   * @param cameraId (Opcional) ID del camara actual para excluirlo de la búsqueda
   * @returns Observable con la respuesta del servidor
   */
  cameraFieldExists(column: string, value: string, cameraId: number | null = null) {
    const data = { column, value, cameraId };
    return this.http.post<{ exists: boolean; camera?: any }>(`${this.baseUrl}/cameraFieldExists`, data);
  }

  /**
   * Obtiene los guardians por municipio
   * @param idMunicipality id del municipio
   * @param active bandera que indica si se deben obtener los guardians activos o no
   * @returns Observable con la lista de guardianes
   */
  getGuardiansByMunicipality(idMunicipality: number, active: boolean): Observable<Guardian[]> {
    return this.http.get<Guardian[]>(`${this.baseUrl}/getGuardiansByMunicipality/${idMunicipality}/${active}`);
  }

  /**
   * Guarda un nuevo guardian
   * @param guardian datos del guardian a guardar
   * @returns Observable
   */
  saveNewGuardian(guardian: Partial<Guardian>): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/saveNewGuardian`, guardian);
  }

  /**
   * Modifica un guardian
   * @param guardian datos del guardian a modificar
   * @returns Observable
   */
  modifyGuardian(guardian: Guardian): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/modifyGuardian`, guardian);
  }

  /**
   * Obtener matriculas agrupadas para la tabla de panel matricula
   * @param camaras camaras
   * @param tipo tipo
   * @param fecha fecha inicial
   * @param fecha2 fecha final
   * @param ZonaHoraria zona horaria
   * @param calculateCount boolean contabilizar registros
   * @param dataPreFilter datos del prefiltro
   */
  getDataPanelMatriculaTable(camaras, tipo, fecha, fecha2, calculateCount, dataPreFilter) {
    return this.http.post(`${this.baseUrl}/getDataPanelMatriculaTable`, {
      camaras,
      tipo,
      fecha,
      fecha2,
      calculateCount,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      language: this.fsession.optenerValor('language'),
      dataPreFilter
    });
  }

  /**
   * Obtener datos para el grafico matriculas agrupadas panel matricula
   * @param matricula matriculas
   * @param fecha fecha incial
   * @param tipo tipo de grafico
   * @param callback funcion de retorno
   */
  getDataGraficoMatriculaTable(matricula, fecha, tipo) {
    return this.http.post(`${this.baseUrl}/getDataGraficoMatriculaTable`, {
      matricula,
      fecha,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      tipo
    });
  }
  getDataGraficoMatriculaTableV2(matricula, fecha, tipo) {
    return this.http.post(`${this.baseUrl}/getDataGraficoMatriculaTableV2`, {
      matricula,
      fecha,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      tipo
    });
  }
  /**
   * Traer detecciones de una matrícula en el municipio para el panel matricula
   * @param matricula Matricula
   * @param fecha Fecha a Consultar
   * @param tipo Rango de fecha
   * @returns observable
   */
  TraerTrazabilidadMatriculaPanelMatricula(matricula, fecha, tipo, idmunicipio) {
    return this.http.post(`${this.baseUrl}/TraerTrazabilidadMatriculaPanelMatricula`, {
      matricula,
      fecha,
      tipo,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      idmunicipio
    });
  }

  /**
   * Obtiene grupos por municipio para visor avanzado
   * @param idMunicipio ID(s) del municipio o un array de IDs
   * @returns Observable
   */
  getGroupsByMunicipalityInVisorAvanzado(idMunicipio: number): Observable<Group[]> {
    const data = {
      idMunicipio: idMunicipio,
    }
    return this.http.post<any>(`${this.baseUrl}/getGroupsByMunicipalityInVisorAvanzado`, data);
  }

  /**
   * Descarga una imagen desde el backend
   * @param url URL de la imagen en Azure Blob Storage
   * @returns Blob
   */
  downloadImageFromAzure(url: string): Observable<Blob> {
    const options = { responseType: 'blob' as 'json' }; // Configuración para recibir un blob
    return this.http.get<Blob>(`${this.baseUrl}/downloadImage`, { params: { url }, ...options });
  }

  /**
   * Obtiene informacion de la tabla "deteccionVehiculos"
   * @returns Observable
   */
  getFirmwareGroupByTipoCamara(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/getFirmwareGroupByTipoCamara`);
  }

  /**
   * Obtiene informacion de la vista "camarasByVersionFirmware"
   * @param {*} versionFirmwareFilter version del firmware a filtrar
   * @returns Observable
   */
  camarasByVersionFirmware(versionFirmwareFilter: number): Observable<Group[]> {
    const data = {
      versionFirmwareFilter: versionFirmwareFilter,
    }
    return this.http.post<any>(`${this.baseUrl}/camarasByVersionFirmware`, data);
  }

  /**
   * Obtiene informacion de la vista "Registros_VehiculosDB_Detecciones_Car"
   * @returns Observable
   */
  Registros_VehiculosDB_Detecciones_Car(): Observable<any[]> {
    return this.http.get<any>(`${this.baseUrl}/Registros_VehiculosDB_Detecciones_Car`);
  }

  /**
   * Obtiene informacion de la tabla de la zona horaria por id
   * @param {*} idZona id de la zona horaria
   */
  getDataTableZonaHoraria(idZona) {
    const data = {
      idZona: idZona,
    };
    return this.http.post(`${this.baseUrl}/getDataTableZonaHoraria`, data);
  }

  /**
   * Descarga un video desde el backend
   * @param url URL del video en Azure Blob Storage
   * @returns Blob
   */
  downloadVideoFromAzure(url: string): Observable<Blob> {
    const options = { responseType: 'blob' as 'json' };
    const data = { url };

    return this.http.post<Blob>(`${this.baseUrl}/downloadVideoFromAzure`, data, options);
  }

  /**
   * Obtiene la lista de usuarios de Azure AD B2C
   * @returns Observable con los usuarios
   */
  getUsersB2C(filterUsers: number = 1) {
    return this.http.get<any>(`${this.baseUrl}/getUsersB2C/${filterUsers}`);
  }

  /**
   * Obtiene la primera imagen por día u hora para una cámara dada
   * @param idCamara Identificador de la cámara
   * @param tipoFiltro 'day' para primero de cada día o 'hour' para primero de cada hora
   * @param fechaInicio Fecha de inicio en formato ISO (YYYY-MM-DD HH:mm:ss)
   * @param fechaFin Fecha de fin en formato ISO (YYYY-MM-DD HH:mm:ss)
   * @returns Observable con arreglo de registros EventoCam
   */
  eventosCamByTime(id_camara: string, tipoFiltro: 'day' | 'hour', fechaInicio: any, fechaFin: any, changeContenedor = true): Observable<any[]> {
    const data = {
      id_camara: id_camara,
      tipoFiltro: tipoFiltro,
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      changeContenedor: changeContenedor
    };
    return this.http.post<any[]>(`${this.baseUrl}/eventosCamByTime`, data);
  }


  /**
   * Envía datos de la lista de interes para agregar esa lista a una camara
   * @param data Objeto que contiene los datos de la camara y lista
   * @returns Observable con la respuesta del backend
   */
  sendListUrls(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/sendListUrls`, data);
  }

  /**
   * Guarda una nueva descarga de timelapse
   * @param descarga Objeto con los datos a insertar
   * @returns Observable con { ok: boolean; insertedId: number; }
   */
  saveDescargaTimelapse(data: DescargaTimelapse): Observable<DescargaTimelapse[]> {
    return this.http.post<any[]>(`${this.baseUrl}/saveDescargaTimelapse`, data);
  }

  /**
   * Obtiene las descargas de timelapse para un usuario dado.
   * @param usuarioId – Identificador del usuario
   * @returns Observable con la lista de descargas
   */
  getDescargasTimelapsePorUsuario(id_usuario: number, typeFilter: 'TODOS' | 'PENDIENTE' | 'DISPONIBLE' | 'CADUCADO', checkSeeAllUser: boolean, id_municipio: number): Observable<DescargaTimelapse[]> {
    return this.http.get<any>(`${this.baseUrl}/getDescargasTimelapsePorUsuario/${id_usuario}/${typeFilter}/${checkSeeAllUser}/${id_municipio}`);
  }

  /**
   * Obtiene el url video de timelapse por nombre de archivo
   * @param nombreArchivo Nombre del archivo a descargar
   * @returns 
   */
  getTimelapseVideo(nombreArchivo: string): Observable<any[]> {
    return this.http.get<any>(`${this.baseUrl}/getTimelapseVideo/${nombreArchivo}`);
  }

  /**
   * Actualiza el estado de una descarga de timelapse
   * @param id      – ID de la descarga a actualizar
   * @param estado  – Nuevo estado ('PENDIENTE' | 'DISPONIBLE' | 'CADUCADO', etc.)
   * @returns
   */
  updateTableDescargasTimelapse(id: number, estado: string): Observable<{ ok: boolean; message: string }> {
    const data = { id, estado };
    return this.http.post<{ ok: boolean; message: string }>(`${this.baseUrl}/updateTableDescargasTimelapse`, data);
  }

  /**
   * Obtiene las descargas pendientes multiples (es decir las descargas de varias camaras) por su id de relacion
   * @param idMultipleDescarga id de relacion de las descargas pendientes
   * @returns Observable con la lista de descargas pendientes
   */
  getMultiplePendingDownloadsByID(idMultipleDescarga: string): Observable<DownloadPending[]> {
    return this.http.get<{ ok: boolean, result: DownloadPending[] }>(
      `${this.baseUrl}/getMultiplePendingDownloadsByID/${idMultipleDescarga}`
    ).pipe(map((response: { ok: boolean, result: DownloadPending[] }) => response.result));
  }
  getMultiplePendingDownloadsByIdsArray(idsMultiDownload: any): Observable<DownloadPending[]> {
    return this.http.post<{ ok: boolean, result: DownloadPending[] }>(
      `${this.baseUrl}/getMultiplePendingDownloadsByIdsArray`, { idsMultiDownload }
    ).pipe(map((response: { ok: boolean, result: DownloadPending[] }) => response.result));
  }
  /**
   * Obtiene el numero de dispositivos router por camara
   * @param id_soporte id de soporte
   * @param id_camara id de camara
   * @returns
   */
  getNumDispositivosRouterByCamera(id_soporte: number, id_camara: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/getNumDispositivosRouterByCamera/${id_soporte}/${id_camara}`);
  }

  /**
   * Obtiene la lista de zonas zar
   * @param id id de la zona zar
   * @param activo Filtro por activo
   * @returns
   */
  getZonaZar(id: number, activo: boolean): Observable<{ ok: boolean; data: ZonaZar }> {
    return this.http.get<{ ok: boolean; data: ZonaZar }>(
      `${this.baseUrl}/getZonaZar/${id}/${activo}`
    );
  }

  /**
   * Guarda una zona zar
   * @param zona datos de la zona zar a guardar
   * @returns 
   */
  createZonaZar(zona: Partial<ZonaZar>): Observable<{ ok: boolean; message: string }> {
    return this.http.post<{ ok: boolean; message: string }>(
      `${this.baseUrl}/createZonaZar`,
      zona
    );
  }

  /**
   * Actualiza una zona zar
   * @param id id de la zona zar a actualizar
   * @param zona datos de la zona zar
   * @returns
   */
  updateZonaZar(zona: Partial<ZonaZar>): Observable<{ ok: boolean; message: string }> {
    return this.http.put<{ ok: boolean; message: string }>(
      `${this.baseUrl}/updateZonaZar`,
      zona
    );
  }

  /**
   * Obtiene la lista de sentidos de camara
   */
  getSentidoCamara(): Observable<{ ok: boolean; data: SentidoCamara[] }> {
    return this.http.get<{ ok: boolean; data: SentidoCamara[] }>(
      `${this.baseUrl}/getAllSentidoCamara`
    );
  }

  /**
   * Obtiene una camara por zona zar
   * @param id id de la camara
   * @param activo Filtro por activo
   * @returns 
   */
  getCamaraZonaZar(id: number, activo: boolean): Observable<{ ok: boolean; data: CamaraZonaZar }> {
    return this.http.get<{ ok: boolean; data: CamaraZonaZar }>(
      `${this.baseUrl}/getCamaraZonaZar/${id}/${activo}`
    );
  }

  /**
   * Crea una nueva camara por zona zar
   * @param camaraZona datos de la camara
   * @returns
   */
  createCamaraZonaZar(camaraZona: Partial<CamaraZonaZar>): Observable<{ ok: boolean; message: string }> {
    return this.http.post<{ ok: boolean; message: string }>(
      `${this.baseUrl}/createCamaraZonaZar`,
      camaraZona
    );
  }

  /**
   * Actualiza una camara por zona zar
   * @param id id de la camara
   * @param camaraZona datos de la camara
   * @returns
   */
  updateCamaraZonaZar(camaraZona: Partial<CamaraZonaZar>): Observable<{ ok: boolean; message: string }> {
    return this.http.put<{ ok: boolean; message: string }>(
      `${this.baseUrl}/updateCamaraZonaZar`,
      camaraZona
    );
  }

  /**
   * Obtiene zbe por municipio
   * @param municipio id de municipio
   * @returns observable
   */
  getZonaZbe(id_zbe = null) {
    if (id_zbe) {
      return this.http.get(`${this.baseUrl}/getZonaZbe/${id_zbe}`);
    }
    return this.http.get(`${this.baseUrl}/getZonaZbe`);
  }

  /**
   * Obtiene url de imagen
   * @param archivo archivo
   * @returns Observable
   */
  ObtenerUrlImagen(archivo: string, type: TypeStorageByGetUrlImage, containerName = null): Observable<{ url: string, mensaje: string }> {
    return this.http.get<{ url: string, mensaje: string }>(`${this.baseUrl}/ObtenerUrlImagen/${archivo}/${type}/${containerName}`);
  }

  /**
 * Obtiene url de imagen
 * @param archivo archivo
 * @returns Observable
 */
  ObtenerUrlImagenPost(archivo: string | string[], type: TypeStorageByGetUrlImage, containerName = null): Observable<{ url: any, mensaje: string }> {
    return this.http.post<{ url: any[], mensaje: string }>(`${this.baseUrl}/ObtenerUrlImagenPost`, { archivo, type, containerName });
  }

  /**
   * Envía datos para generar una imagen con metadatos de una cámara
   * @param data Objeto que contiene los datos de la camara
   * @returns Observable
   */
  obtenerImagenMetadatos(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/obtenerImagenMetadatos`, data);
  }

  /**
   * obtener las matriculas permitidas para una zona zar
   */
  getMatriculasPermitidasZar(idMunicipio: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/getMatriculasPermitidasZar/${idMunicipio}`);
  }

  /**
   * Descarga la informacion de determinado video desde el servidor
   * @param informationToDownload Información necesaria para descargar el archivo de video
   * @returns un observable que emite el id de metadatos y el nombre del archivo en el storage
   */
  downloadVideo(informationToDownload: InformationToDownload)
    : Observable<{ ok: boolean, data: { id_metadatos: number, filename_src: string } }> {
    return this.http.post<{ ok: boolean, data: { id_metadatos: number, filename_src: string } }>(
      `${this.baseUrl}/donwloadVideo`, informationToDownload
    );
  }

  /**
   * Sube una imagen de soporte asociada a un registro de la tabla camara con id {@param id_record}.
   * y se guarda con el nombre {@param file_name}.
   * @param id_record id del registro de metadatos al que se asocia la imagen
   * @param id_camera id de la cámara a la que se asocia la imagen
   * @param file_name nombre con el que se guardará la imagen
   * @param file imagen a subir
   * @param nameFileCurrent nombre de la imagen actual
   * @returns Observable que emite la respuesta del servidor
   */
  uploadSupportImageMetadata(id_record: number, id_camera: string, file_name: string, file: File, nameFileCurrent: string = null):
    Observable<{ ok: boolean, message: string }> {
    const formDataBody: FormData = new FormData();
    formDataBody.append('id_record', id_record.toString());
    formDataBody.append('id_camera', id_camera);
    formDataBody.append('file_name', file_name);
    formDataBody.append('file', file, file.name);
    if (nameFileCurrent) formDataBody.append('nameFileCurrent', nameFileCurrent);

    return this.http.post<{ ok: boolean, message: string }>(`${this.baseUrl}/uploadSupportImageMetadata`, formDataBody);
  }

  /**
   * Obtiene la imagen de soporte de metadatos asociada a la cámara con el id {@param id_camera}
   * @param id_camera id de la cámara
   * @returns Observable que emite un objeto con la propiedad "metadata_support_image" que puede ser null o un string
   */
  getMetadataSupportImageInCamera(id_camera: number): Observable<{ metadata_support_image: string | null }> {
    return this.http.get<{ metadata_support_image: string | null }[]>(`${this.baseUrl}/getMetadataSupportImageInCamera/${id_camera}`)
      .pipe(map((response: { metadata_support_image: string | null }[]) => response[0]));
  }

  /**
   * Obtener cámaras filtradas por municipio y su firmware
   */
  getCameraFirmware(id_municipio: number): Observable<CameraFirmware[]> {
    return this.http.get<CameraFirmware[]>(`${this.baseUrl}/getCameraFirmware/${id_municipio}`);
  }

  /** 
   * obtiene el historial de cambios de una matricula
   */
  getHistorialMatricula(matricula: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/getHistorialMatriculas/${matricula}`);
  }

  /** 
   * obtiene los tipos de falso rojo
   */
  getTiposFalsoRojo(): Observable<any> {
    return this.http.get(`${this.baseUrl}/getTiposFalsoRojo`);
  }

  /** 
   * obtiene los estados de las infracciones
   */
  getEstadosInfraccion(): Observable<any> {
    return this.http.get(`${this.baseUrl}/getEstadosInfraccion`);
  }

  /**
   * Actualiza el estado y la fecha de última modificación de infracciones por id_eventoscam.
   * @param id_eventoscam id del evento
   * @param id_estado_infraccion id del estado
   * @returns
   */
  updateEstadoInfraccion_InfraccionesDB(id_eventoscam: number, id_estado_infraccion: number): Observable<any> {
    const data = { id_eventoscam, id_estado_infraccion };
    return this.http.post<any>(`${this.baseUrl}/updateEstadoInfraccion_InfraccionesDB`, data);
  }

  /**
   * Crear un estado de infracción
   * @param data - Datos del estado de infracción a crear
   * @returns
   */
  createEstadoInfraccion(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/createEstadoInfraccion`, data);
  }

  /**
   * Actualizar un estado de infracción
   * @param data - Datos del estado de infracción a actualizar
   * @returns
   */
  updateEstadoInfraccion(data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/updateEstadoInfraccion`, data);
  }

  actualizarVerificacionInfracción(data: { id: number, estado: number, correcto: boolean, matricula: string, posiciones: string }) {
    return this.http.put(`${this.baseUrl}/actualizarVerificacionInfraccion`, data);
  }

  /**
   * Actualiza el estado de la infracción para la verificación 1 (solo id estado) o verificación 2 (correcto y estado)
   * @param data Estado de infracción
   * @returns Observable
   */
  actualizarVerificacionZar(data: { id: number, estado: number, correcto?: boolean, matricula: string, posiciones: string }) {
    return this.http.put(`${this.baseUrl}/actualizarVerificacionZar`, data);
  }

  TraerEstadoVerificacion(etapa) {
    return this.http.get(`${this.baseUrl}/TraerEstadoVerificacion/${etapa}`);
  }

  /**
   * Actualiza la configuración de selección de imágenes de infracción por id_eventoscam
   * @param {*} data - Objeto con los nuevos datos de la configuración
   * @param {*} callback
   */
  config_select_imgs_infraccion(data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/config_select_imgs_infraccion`, data);
  }

  /** 
   * Obtiene la configuración de selección de imágenes de infracción por id_eventoscam
   */
  get_config_select_imgs_infraccion(id_eventoscam: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/get_config_select_imgs_infraccion/${id_eventoscam}`);
  }

  /**
   * Archiva una solicitud de descarga pendiente por su id
   * @param donwloadID - Id de la solicitud de descarga pendiente
   * @returns observable que se resuelve con el estado de la solicitud de descarga en el campo 'archivado' de la respuesta
   * @example
   * databaseService.archiveDownloadRequest(1).subscribe(response => {
   *   if (response === StateDownloadArchived.SUCCESS) {
   *     console.log('Descarga archivada correctamente');
   *   } else if (response === StateDownloadArchived.ERROR) {
   *     console.log('Error al archivar la descarga');
   *   }
   * });
   */
  archiveDownloadRequest(donwloadID: number): Observable<StateDownloadArchived> {
    const bodyRequest = { downloadsId: donwloadID };
    return this.http.post<{ ok: boolean, message: string }>(`${this.baseUrl}/archiveDownload`, bodyRequest)
      .pipe(
        delay(1000),
        switchMap(() => this.getPendingDownloadById(donwloadID)),
        map((downloadInfo) => downloadInfo?.data?.archivado ?? StateDownloadArchived.DEFAULT),
        catchError(() => of(StateDownloadArchived.ERROR))
      );
  }
  getDowloadsArchived(Archivo: string): Observable<any> {

    return this.http.post(`${this.baseUrl}/getDowloadsArchived`, { Archivo })
  }
  /**
   * Obtiene la informacion de una solicitud de descarga pendiente
   * @param id_download Identificador de la solicitud de descarga
   * @returns Observable que emite un objeto con la informacion de la solicitud de descarga
   */
  getPendingDownloadById(id_download: number): Observable<{ ok: boolean, data: Partial<DonwnloadPendingProcessed> }> {
    return this.http.get<{ ok: boolean, data: Partial<DonwnloadPendingProcessed> }>(`
      ${this.baseUrl}/getPendingDownloadById/${id_download}`
    );
  }

  /**
   * Solicita al usuario seleccionar una carpeta para guardar archivos
   * y valida permisos de escritura
   */
  async requestDownloadFolder(translations: any, verifyPermissionFn: (handle: FileSystemDirectoryHandle) => Promise<boolean>): Promise<FileSystemDirectoryHandle> {
    // Verifica compatibilidad
    if (!('showDirectoryPicker' in window)) {
      throw translations.funcion_no_disponible_en_navegador;
    }

    try {
      // Solicita al usuario la carpeta de destino
      const directoryHandle: FileSystemDirectoryHandle = await (window as any).showDirectoryPicker();

      // Verifica permisos usando la función que le pases (ej: tu MultipleDownloadService)
      const isPermissionGranted = await verifyPermissionFn(directoryHandle);

      if (!isPermissionGranted) {
        throw translations.debes_conceder_permiso_para_guardar_los_archivos;
      }

      return directoryHandle;

    } catch (error) {
      throw error;
    }
  }

  /**
   * Módulo Infracciones
   */

  /**
 * Traer informacion de matriculas
 * @param matricula filtro por matricula del vehiculo
 * @param municipio Municipio
 * @param FechaI Fecha de inicio de las detecciones
 * @param FechaF Fecha de fin de las detecciones
 * @param CamSel Cámaras de detecciones
 * @param idioma Idioma a mostrar
 * @param soloFotoRojo Si se muestran solo las infracciones
 * @param color filtro por color
 * @param TipoDeteccion Filtro por deteccion
 * @param marca filtro por marca del vehiculo
 * @param velocidadInicial filtro de por velocidad del vehiculo
 * @param velocidadFinal filtro de por velocidad del vehiculo
 * @returns
 */
  TraerInfraccionesFotoRojo(
    matricula: string,
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    soloFotoRojo: boolean,
    color: string,
    TipoDeteccion: string,
    marca: string,
    velocidadInicial: number,
    velocidadFinal: number,
    noplate: boolean,
    listVehicleInterests: string
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      matricula,
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      soloFotoRojo: soloFotoRojo,
      color: color,
      TipoDeteccion: TipoDeteccion,
      marca: marca,
      velocidadInicial: velocidadInicial,
      velocidadFinal: velocidadFinal,
      noplate: noplate,
      listVehicleInterests: listVehicleInterests
    };
    return this.http.post<any>(`${this.baseUrl}/TraerInfraccionesFotoRojo`, data);
  }

  /**
 * Traer informacion de matriculas
 * @param matricula filtro por matricula del vehiculo
 * @param municipio Municipio
 * @param FechaI Fecha de inicio de las detecciones
 * @param FechaF Fecha de fin de las detecciones
 * @param CamSel Cámaras de detecciones
 * @param idioma Idioma a mostrar
 * @param soloFotoRojo Si se muestran solo las infracciones
 * @param color filtro por color
 * @param TipoDeteccion Filtro por deteccion
 * @param marca filtro por marca del vehiculo
 * @param velocidadInicial filtro de por velocidad del vehiculo
 * @param velocidadFinal filtro de por velocidad del vehiculo
 * @returns
 */
  TraerInfraccionesPasoCebra(
    matricula: string,
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    soloFotoRojo: boolean,
    color: string,
    TipoDeteccion: string,
    marca: string,
    velocidadInicial: number,
    velocidadFinal: number,
    noplate: boolean,
    listVehicleInterests: string
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      matricula,
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      soloFotoRojo: soloFotoRojo,
      color: color,
      TipoDeteccion: TipoDeteccion,
      marca: marca,
      velocidadInicial: velocidadInicial,
      velocidadFinal: velocidadFinal,
      noplate: noplate,
      listVehicleInterests: listVehicleInterests
    };
    return this.http.post<any>(`${this.baseUrl}/TraerInfraccionesPasoCebra`, data);
  }

  /**
 * Traer informacion de matriculas
 * @param etapaVerificacion Etapa de la verificación de infracción (1 = Verificación 1, 2 = verificación 2 , null = todo)
 * @param matricula filtro por matricula del vehiculo
 * @param municipio Municipio
 * @param FechaI Fecha de inicio de las detecciones
 * @param FechaF Fecha de fin de las detecciones
 * @param CamSel Cámaras de detecciones
 * @param idioma Idioma a mostrar
 * @param traerTodas Si se muestran solo las infracciones
 * @param color filtro por color
 * @param TipoDeteccion Filtro por deteccion
 * @param marca filtro por marca del vehiculo
 * @param velocidadInicial filtro de por velocidad del vehiculo
 * @param velocidadFinal filtro de por velocidad del vehiculo
 * @returns
 */
  TraerInfraccionesPasoZAR(
    etapaVerificacion: number,
    matricula: string,
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    traerTodas: boolean,
    color: string,
    TipoDeteccion: string,
    marca: string,
    velocidadInicial: number,
    velocidadFinal: number,
    noplate: boolean,
    listVehicleInterests: string
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      etapaVerificacion,
      matricula,
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      traerTodas: traerTodas,
      color: color,
      TipoDeteccion: TipoDeteccion,
      marca: marca,
      velocidadInicial: velocidadInicial,
      velocidadFinal: velocidadFinal,
      noplate: noplate,
      listVehicleInterests: listVehicleInterests
    };
    return this.http.post<any>(`${this.baseUrl}/TraerInfraccionesZAR`, data);
  }

  TraerInfraccionesZarDGT(
    matricula: string,
    municipio: string | number,
    FechaI: string,
    FechaF: string,
    CamSel: any[],
    idioma: string,
    traerTodas: boolean,
    color: string,
    TipoDeteccion: string,
    marca: string,
    velocidadInicial: number,
    velocidadFinal: number,
    noplate: boolean,
    listVehicleInterests: string
  ): Observable<{ matricula: LicensePlateInformation[] }> {
    const data = {
      matricula,
      municipio: municipio,
      FechaI: FechaI,
      FechaF: FechaF,
      CamSel: CamSel,
      idioma: idioma,
      zonaHoraria: this.fsession.optenerValor("dato41"),
      traerTodas: traerTodas,
      color: color,
      TipoDeteccion: TipoDeteccion,
      marca: marca,
      velocidadInicial: velocidadInicial,
      velocidadFinal: velocidadFinal,
      noplate: noplate,
      listVehicleInterests: listVehicleInterests
    };
    return this.http.post<any>(`${this.baseUrl}/TraerInfraccionesZarDGT`, data);
  }

  /**
   * Obtiene el registro de dgt para la matrícula
   * @param matricula Matricula a buscar
   * @returns 
   */
  historialMatriculasDGT(matricula: string) {
    return this.http.get<any>(`${this.baseUrl}/historialMatriculasDGT/${matricula}`);
  }

  asignarRegistroDGT(idInfraccion, idDatosDGT) {
    return this.http.put(`${this.baseUrl}/asignarRegistroDGT/${idInfraccion}`, { idDatosDGT });
  }

  /**
   * Obtiene los envios generados para un tipo de infracción
   * @param idTipoInfraccion Id de la definición del tipo de infracción
   * @returns 
   */
  obtenerEnviosInfracciones(idTipoInfraccion: number, estadoEnvios: string, fechaInicio, fechaFin) {
    return this.http.post<any>(`${this.baseUrl}/TraerEnviosInfracciones/${idTipoInfraccion}/${estadoEnvios}`, {
      fechaInicio, fechaFin
    });
  }

  descargarEnvioInfracciones(idEnvio: number) {
    return this.http.post(`${this.baseUrl}/descargarEnvioInfracciones`, { idEnvio }, { responseType: 'blob' });
  }

  MarcarEnvioInfraccionesDescargado(idEnvio: number) {
    return this.http.put(`${this.baseUrl}/MarcarEnvioInfraccionesDescargado`, { idEnvio });
  }

  /**
   * Obtiene las infracciones que hacen parte de un paquete de envios
   * @param idEnvio Id paquete de envio
   * @returns 
   */
  obtenerInfracionesIdEnvio(idEnvio: number, tipoInfraccion: 'FOTO_ROJO' | 'PASO_CEBRA' | 'ZAR') {
    return this.http.get<any>(`${this.baseUrl}/TraerInfracionesEnvio/${idEnvio}/${tipoInfraccion}`);
  }

  TraerFormatosPorTipo(idTipoFormato: number) {
    return this.http.get<[]>(`${this.baseUrl}/TraerFormatosPorTipo/${idTipoFormato}`)
  }

  TraerMetodosEnvioPorTipo(idTipoENvio: number) {
    return this.http.get<[]>(`${this.baseUrl}/TraerMetodosEnvioPorTipo/${idTipoENvio}`)
  }

  TraerTiposEnvioInfracciones() {
    return this.http.get<TipoEnvioInfraccion[]>(`${this.baseUrl}/TraerTiposEnvioInfracciones`)
  }

  TraerFormatoEnvioInfracciones() {
    return this.http.get<TipoEnvioInfraccion[]>(`${this.baseUrl}/TraerFormatoEnvioInfracciones`)
  }

  TraerTipoVehiculosDGT() {
    return this.http.get<{ data: any[] }>(`${this.baseUrl}/TraerTipoVehiculosDGT`)
  }

  /**
   * Sube imagen de soporte
   * @param supportImage imagen a subir 
   * @returns Observable
   */
  SubirFotoRecorteOCR(supportImage: File, idInfraccion: number, nombreArchivoRaiz: string, tipoInfraccion: TIPOS_INFRACCIONES, confirmada: boolean): Observable<any> {
    let form: FormData = new FormData();

    form.append("file", supportImage, supportImage.name);
    form.append("idInfraccion", idInfraccion.toString());
    form.append("nombreArchivoRaiz", nombreArchivoRaiz);
    form.append("tipoInfraccion", tipoInfraccion.toString());
    form.append("confirmada", confirmada.toString());

    return this.http.post(`${this.baseUrl}/SubirRecorteOCR`, form);
  }

  /**
   * Trae detalle infracción zar
   * TODO: Mover a servicio específico de infracciones ZAR
   * @param matricula 
   * @param idInfraccion 
   * @returns 
   */
  datosInfraccion(matricula: string, idInfraccion: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/datosInfraccion/${matricula}/${idInfraccion}`);
  }

  getPaneles() {
    return this.http.post(`${this.baseUrl}/getPaneles`, {})
  }

  createPlantillaPanel(data: any, idMunicipality: string) {
    return this.http.post(`${this.baseUrl}/createPlantillaPanel`, { ...data, idMunicipality })
  }

  updatePlantillaPaneles(data: any, idMunicipality: string) {
    return this.http.post(`${this.baseUrl}/updatePlantillaPaneles`, { ...data, idMunicipality })
  }

  getPlantillasPaneles() {
    const idMunicipality = this.fsession.optenerValor("dato4");
    return this.http.post(`${this.baseUrl}/getPlantillasPaneles`, { idMunicipality })
  }

  getDataPlantilla(idPanel: number) {
    return this.http.post(`${this.baseUrl}/getDataPlantilla`, { idPanel })
  }
  getGraficoTelemetria(data: any) {
    return this.http.post(`${this.baseUrl}/getGraficoTelemetria`, data)
  }
  InfoCamarasApi(
    Soporte: any,
    IdMunicipio: number,
    Valor: string,
    Activa: boolean,
    Idioma: string,
    sort: { active: string, direction: '' | 'asc' | 'desc' }
  ): Observable<CamaraG[]> {
    const data = {
      Soporte: Soporte,
      IdMunicipio: IdMunicipio,
      Valor: Valor,
      Activa: Activa,
      Idioma: Idioma,

      sort
    };
    return this.http.post<CamaraG[]>(`${this.baseUrl}/InfoCamarasApi`, data);
  }

  getDeviceInfo(ipCamara: string, idCamara: string) {
    const idMunicipio = this.fsession.optenerValor("dato4");
    return this.http.post(`${this.baseUrl}/getDeviceInfo`, { ipCamara, idCamara, idMunicipio })
  }

  GetDeviceInfoDigest(ipCamara: string, idCamara: string) {
    const idMunicipio = this.fsession.optenerValor("dato4");
    return this.http.post(`${this.baseUrl}/GetDeviceInfoDigest`, { ipCamara, idCamara, idMunicipio })
  }


  /**
   * Obtiene los subtipos de cámaras disponibles
   * @returns Un observable con los subtipos de cámaras
   */
  getSubtypesCameras(): Observable<SubtypeCamera[]> {
    return this.http.get<{ ok: boolean, data: SubtypeCamera[] }>(`${this.baseUrl}/getSubtypesCameras`)
      .pipe(map((response: { ok: boolean, data: SubtypeCamera[] }) => response.data));
  }

  /**
   * Actualiza un subtipo de cámaras
   * @param subtypeCamera Subtipo de cámara a actualizar
   * @returns Un observable con el resultado de la actualización
   */
  updateSubtypeCamera(subtypeCamera: SubtypeCamera): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(`${this.baseUrl}/updateSubtypeCamera`, subtypeCamera);
  }

  /**
   * Crea un nuevo subtipo de cámaras
   * @param subtypeCamera datos del subtipo de cámara
   * @returns On observable con el resultado de la creación
   */
  createSubtypeCamera(subtypeCamera: Omit<SubtypeCamera, 'id_subtipo'>): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.baseUrl}/createSubtypeCamera`, subtypeCamera);
  }

  /**
   * Realiza una traduccion de un texto en diferentes idiomas
   * utilizando la API de traduccion correspondiente (lingva o mymemory)
   * @param apiTranslation nombre de la API de traduccion a utilizar
   * @param texto texto a traducir
   * @param originLanguage idioma original del texto
   * @param languagesTranslate array de idiomas a traducir
   * @returns Promesa que se resuelve con un objeto que contiene las traducciones
   * donde cada clave es el idioma y su valor es la traduccion correspondiente
   */
  async translationText(
    apiTranslation: 'lingva' | 'mymemory',
    text: string,
    originLanguage: string,
    languagesTranslate: string[] = []
  ): Promise<{ [lang: string]: string }> {

    const providerTranslation = getTranslationProvider(apiTranslation);

    const requestsTranslations = languagesTranslate
      .filter(language => language !== originLanguage)
      .map(async (language) => {
        const fromLang = language === 'va' ? 'ca' : language === 'pv' ? 'eu' : language;
        const urlRequest = providerTranslation.buildUrl(originLanguage, fromLang, text);
        const responseRequest = await fetch(urlRequest);
        const data = await responseRequest.json();
        return { lang: language, translation: providerTranslation.parseResponse(data) };
      });

    const results = await Promise.all(requestsTranslations);
    const translations: { [lang: string]: string } = {};
    results.forEach(res => translations[res.lang] = res.translation);

    return translations;
  }

  /**
   * Realiza una petición a la API para obtener detecciones de foto rojo
   * @param payload datos de la petición
   * @returns Un observable con la respuesta de la petición
   */
  getDetectionPhotoRed(payload: DetectionPhotoRedRequest): Observable<DetectionPhotoRed[]> {
    return this.http.post<DetectionPhotoRed[]>(`${this.baseUrl}/getDetectionPhotoRed`, payload);
  }

  /**
   * Realiza una petición a la API para obtener la configuración de envio
   * @returns 
   */
  getConfiguracionEnvio() {
    return this.http.post(`${this.baseUrl}/getConfiguracionEnvio`, {});
  }

  /**
   * Realiza una petición a la API para obtener la configuración de formato
   * @returns
   */
  getConfiguracionFormato() {
    return this.http.post(`${this.baseUrl}/getConfiguracionFormato`, {});
  }

  /**
   * Realiza una petición a la API para obtener la configuración de envio
   * @param id_configuracion - id de la configuración
   * @returns
   */
  getConfiguracionEnvioByid(id_configuracion: number) {
    return this.http.post(`${this.baseUrl}/getConfiguracionEnvioByid`, { id_configuracion });
  }

  /**
   * Realiza una petición a la API para obtener la configuración de formato
   * @param id_configuracion - id de la configuración
   * @returns
   */
  getConfiguracionFormatoById(id_configuracion: number) {
    return this.http.post(`${this.baseUrl}/getConfiguracionFormatoById`, { id_configuracion });
  }

  /**
   * Realiza una petición a la API para insertar la configuración de envio
   * @param data - datos de la configuración
   * @returns
   */
  InsertarConfiguracionEnvio(data: any) {
    return this.http.post(`${this.baseUrl}/InsertarConfiguracionEnvio`, data);
  }

  /**
   * Realiza una petición a la API para insertar la configuración de formato
   * @param data - datos de la configuración
   * @returns
   */
  insertarConfiguracionFormato(data: any) {
    return this.http.post(`${this.baseUrl}/insertarConfiguracionFormato`, data);
  }

  /**
   * Realiza una petición a la API para editar la configuración de envio
   * @param data - datos de la configuración
   * @returns 
   */
  editarConfiguracionEnvio(data: any) {
    return this.http.put(`${this.baseUrl}/editarConfiguracionEnvio`, data);
  }

  /**
   * Realiza una petición a la API para editar la configuración de formato
   * @param data - datos de la configuración
   * @returns
   */
  editarConfiguracionFormato(data: any) {
    return this.http.put(`${this.baseUrl}/editarConfiguracionFormato`, data);
  }

  /**
   * Realiza una petición a la API para obtener los usuarios de un municipio
   * @param idMunicipality - id del municipio
   * @returns
   */
  getUsersByMunicipalityAndB2c(idMunicipality: number) {
    return this.http.get(`${this.baseUrl}/getUsersByMunicipalityAndB2c/${idMunicipality}`);
  }

  /**
   * Realiza una petición a la API para obtener todos los routers
   * @returns 
   */
  obtenerALLRouters() {
    return this.http.post(`${this.baseUrl}/obtenerALLRouters/`, {});
  }

  /**
   * Obtiene los submodulos disponibles
   * @returns 
   */
  obtenerSubmodulo() {
    return this.http.get(`${this.baseUrl}/obtenerSubmodulos/`);
  }

  /**
   * Obtiene los tipos de submodulos
   * @returns 
   */
  ObtenerTipoSubmodulos() {
    return this.http.get(`${this.baseUrl}/ObtenerTipoSubmodulos/`);
  }

  /**
   * Crea un submodulo
   * @param submodulo - Submodulo
   * @returns 
   */
  crearSubmodulo(submodulo: Submodulo) {
    const data = {
      ...submodulo
    };

    return this.http.post(`${this.baseUrl}/crearSubmodulo`, data);
  }

  /**
   * Obtiene los permisos de los submodulos
   * @param idSubmodulo - Id del submodulo
   * @returns
   */
  getSubmodulesPermissions(idSubmodulo: number[]): Observable<any> {
    const encryptedIds = JSON.stringify(idSubmodulo);
    return this.http.post(`${this.baseUrl}/getSubmodulesPermissions`, { idSubmodulo: encryptedIds });
  }

  /**
   * Agrega submodulos enlazados
   * @param submodulo - Submodulo
   * @param idsEnlazados - Ids de los submodulos
   * @returns
   */
  agregarSubmodulosEnlazados(submodulo: Submodulo, idsEnlazados: number[]) {
    const data = {
      ...submodulo,
      idsEnlazados
    };

    return this.http.post(`${this.baseUrl}/agregarSubmodulosEnlazados`, data);
  }

  /**
   * Obtiene las ayudas creadas
   * @returns 
   */
  obtenerAyudas(): Observable<{ ayudas: any[] }> {
    return this.http.get<{ ayudas: any[] }>(`${this.baseUrl}/obtenerAyudas`, {});
  }

  /**
   * Guarda la configuración de isla para un municipio determinado
   * @param data datos de la configuración de isla a guardar
   * @returns Observable con la respuesta de la API tras guardar la configuración de isla
   */
  saveIslandConfiguration(data: SaveSettingIsland): Observable<{ message: string, id: number }> {
    return this.http.post<{ message: string, id: number }>(`${this.baseUrl}/saveIslandConfiguration`, data);
  }

  /**
   * Obtiene la configuración de isla para un municipio determinado
   * @param id_municipio id del municipio
   * @param activo bander de activo para filtrar la configuración
   * @returns Observable con la configuración de isla del municipio
   */
  getIslandConfiguration(id_municipio: number, activo: boolean): Observable<SettingIsland[]> {
    return this.http.get<SettingIsland[]>(`${this.baseUrl}/getIslandConfiguration/${id_municipio}/${activo}`);
  }

  /**
   * Actualiza la configuración de isla para un municipio determinado
   * @param data información de la configuración de isla a actualizar (incluye `activo` al editar desde el diálogo)
   * @returns Observable con la respuesta de la API tras actualizar la configuración de isla
   */
  updateIslandConfiguration(data: UpdateSettingIsland): Observable<{ message: string, id: number }> {
    return this.http.put<{ message: string, id: number }>(`${this.baseUrl}/updateIslandConfiguration`, data);
  }

  /**
   * Guarda la configuración del visor de islas para un municipio determinado
   * @param data datos de la configuración del visor de islas a guardar
   * @returns Observable con la respuesta de la API tras guardar la configuración del visor de islas
   */
  saveViewerIslandConfigurationMunicipality(data: Partial<VisorIslandConfigurationMunicipality>): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.baseUrl}/saveViewerIslandConfigurationMunicipality`, data);
  }

  /**
   * Obtiene la configuración del visor de islas para un municipio determinado
   * @param id_municipality id del municipio
   * @returns Observable con la configuración del visor de islas del municipio
   */
  getViewerIslandConfigurationMunicipality(id_municipality: number): Observable<VisorIslandConfigurationMunicipality | null> {
    return this.http.get<VisorIslandConfigurationMunicipality | null>(
      `${this.baseUrl}/getViewerIslandConfigurationMunicipality/${id_municipality}`
    );
  }

  /**
   * Obtiene tipos de permisos para una ruta
   * @returns Observable con el valor de terminoEns
   */
  permisosHabilitadosSubmodulo(idSubmodulo: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/permisosHabilitadosSubmodulo`, { idSubmodulo });
  }

  /**
   * Crea un modulo
   * @param modulo - Modulo
   * @returns 
   */
  crearModulo(modulo: Modulo) {
    const data = {
      ...modulo
    };
    return this.http.post(`${this.baseUrl}/crearModulo`, data);
  }

  /**
   * Modifica un modulo
   * @param modulo - Modulo
   * @returns 
   */
  modificarModulo(modulo: Modulo) {
    const data = {
      ...modulo
    };
    return this.http.post(`${this.baseUrl}/actualizarModulo`, data);
  }

  /**
   * Trae los tipos de permiso que tengan una ayuda relacionada
   * @param idSubmodulo Submódulo
   * @returns 
   */
  tiposPermisosAyudas(idSubmodulo: number): Observable<{ ayudas: any[] }> {
    return this.http.get<{ ayudas: any[] }>(`${this.baseUrl}/tiposPermisosAyudas/${idSubmodulo}`);
  }

  /**
   * Crea una ayuda para un submódulo
   * @param data Ayuda
   * @returns 
   */
  crearAyuda(data): Observable<{ any }> {
    return this.http.post<{ any }>(`${this.baseUrl}/crearAyuda`, data);
  }

  /**
   * Modifica una ayuda que se editó usando el díalogo "Mostrar Ayuda"
   * @param data Ayuda
   * @returns 
   */
  modificarAyuda(data): Observable<{ any }> {
    return this.http.put<{ any }>(`${this.baseUrl}/modificarAyuda`, data);
  }

  /**
   * Modifica una ayuda para el lenguaje epecificado
   * @param data Ayuda
   * @returns 
   */
  modificarAyudaLenguage(data): Observable<{ any }> {
    return this.http.put<{ any }>(`${this.baseUrl}/modificarAyudaLenguage`, data);
  }

  /**
   * Trae las ayudas para un submódulo
   * @param ids Submódulos
   * @returns 
   */
  consultarAyudasSubmodulo(ids): Observable<{ any }> {
    return this.http.post<{ any }>(`${this.baseUrl}/consultarAyudaSubmodulo`, {
      id: ids,
      lang: this.fsession.optenerValor('language') ?? 'es'
    });
  }

  /**
   * Crea un submódulo
   * @param submodulo - Submódulo
   * @returns
   */
  modificarSubmodulo(submodulo: Submodulo) {
    const data = {
      ...submodulo
    };

    return this.http.post(`${this.baseUrl}/actualizarSubmodulo`, data);
  }

  /**
    * Obtiene los permisos especiales de un usuario
    * @param idSubmodulo id del submodulo
    * @returns observable
    */
  getSpecialPermissions(): Observable<{ ok: boolean; result?: any[] }> {
    return this.http.get<{ ok: boolean; result?: any[] }>(`${this.baseUrl}/getSpecialPermissions`);
  }

  /**
   * Crea un permiso especial
   * @param data idSubmodulo, key_identity, descripcion, label_translate
   * @returns observable
   */
  createSpecialPermission(data: { idSubmodulo: number; key_identity: string; descripcion: string; label_translate: string; rolesIds?: number[] }): Observable<any> {
    return this.http.post(`${this.baseUrl}/createSpecialPermission`, data);
  }

  /**
   * Actualiza un permiso especial
   * @param data id, idSubmodulo, key_identity, descripcion, label_translate
   * @returns observable
   */
  updateSpecialPermission(data: { id: number; idSubmodulo?: number; key_identity?: string; descripcion?: string; label_translate?: string; submoduleChanged?: boolean }): Observable<any> {
    return this.http.post(`${this.baseUrl}/updateSpecialPermission`, data);
  }

  /**
    * Obtiene los permisos especiales de un usuario
    * @param idSubmodulo id del submodulo
    * @returns observable
    */
  SubmoduloRolPermisosEspeciales(id_rol: number): Observable<any[]> {
    return this.http.get<any>(`${this.baseUrl}/SubmoduloRolPermisosEspeciales/${id_rol}`)
  }
  traerIncidenciasCamaras(idCamara: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/traerIncidenciasCamaras`, { idCamara });
  }
  traerTipoIncidencias(): Observable<any> {
    return this.http.post(`${this.baseUrl}/traerTipoIncidencias`, {});
  }
  traerTipoResolucionIncidencias
    (): Observable<any> {
    return this.http.post(`${this.baseUrl}/traerTipoResolucionIncidencias
`, {});
  }
  crearIncidencia(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/crearIncidencia`, data);
  }
  crearTipoIncidencia(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/crearTipoIncidencia`, data);
  }
  CrearTipoResolucionIncidencia(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/crearTipoResolucionIncidencia`, data);
  }
  solveIncidencia(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/solveIncidencia`, data);
  }
  updateTipoIncidencia(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/updateTipoIncidencia`, data);
  }
  updateTipoResolucionIncidencia(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/updateTipoResolucionIncidencia`, data);
  }

  InformarEstadoImagenesIslas(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/InformarEstadoImagenes`, data);
  }
  getIslaExternalData(page: number, size: number, id_municipio: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/ListarWatchpoints`, { page, size, id_municipio });
  }

  /**
   * Crea un nuevo dispositivo de foto rojo
   * @param data datos del dispositivo de foto rojo a crear
   * @returns Observable con la respuesta de la API tras crear el dispositivo de foto rojo
   */
  createDevicePhotoRed( data: Partial<DevicePhotoRed> ): Observable<{ message: string, id: number }> {
    return this.http.post<{ message: string, id: number }>(`${this.baseUrl}/createDevicePhotoRed`, data);
  }

  /**
   * Obtiene los dispositivos de foto rojo de un municipio
   * @param active bandera para filtrar los dispositivos activos o inactivos
   * @returns Observable con los dispositivos de foto rojo del municipio
   */
  getDevicesPhotoRedByMunicipality( active: boolean ): Observable<{ ok: boolean, devices: Partial<DevicePhotoRed>[] }> {
    return this.http.get<{ ok: boolean, devices: Partial<DevicePhotoRed>[] }>(`${this.baseUrl}/getDevicesPhotoRedByMunicipality/${active}`);
  }

  /**
   * Obtiene un dispositivo de foto rojo por su ID
   * @param id_device ID del dispositivo de foto rojo
   * @returns Observable con el dispositivo de foto rojo
   */
  getDevicesPhotoRedById(id_device: number): Observable<{ ok: boolean, device: Partial<DevicePhotoRed> }> {
    return this.http.get<{ ok: boolean, device: Partial<DevicePhotoRed> }>(`${this.baseUrl}/getDevicesPhotoRedById/${id_device}`);
  }

  /**
   * Actualiza un dispositivo de foto rojo
   * @param data datos del dispositivo de foto rojo a actualizar
   * @returns Observable con la respuesta de la API tras actualizar el dispositivo de foto rojo
   */
  updateDevicePhotoRed( data: Partial<DevicePhotoRed> ): Observable<{ message: string, id: number }> {
    return this.http.put<{ message: string, id: number }>(`${this.baseUrl}/updateDevicePhotoRed`, data);
  }

  /**
   * Obtiene las infracciones de foto rojo relacionadas con un foto rojo
   * @param params datos para filtrar las infracciones de foto rojo
   * @returns Observable con las infracciones de foto rojo relacionadas con un foto rojo
   */
  getPhotoRedInfractions(params: TraerInfraccionesPasoCebraParams): Observable<{ data: PhotoRedInfraction[] }> {
    return this.http.post<{ data: PhotoRedInfraction[] }>(`${this.baseUrl}/getPhotoRedInfractions`, params);
  }

  /**
   * Obtiene los estados de validación de infracciones para una etapa de validación y tipo de infracción determinados
   * @param etapaValidacion etapa de validación 
   * @param tipoInfraccion tipo de infracción (foto rojo, paso cebra, zar, etc)
   * @returns Observable con los estados de validación de infracciones para la etapa de validación y tipo de infracción especificados
   */
  TraerEstadosValidacionInfracciones(etapaValidacion: number, tipoInfraccion: TIPOS_INFRACCIONES): Observable<{ data: any[] }> {
    return this.http.get<{ data: any[] }>(`${this.baseUrl}/TraerEstadosValidacionInfracciones/${etapaValidacion}/${tipoInfraccion}`);
  }

  /**
   * Realiza una petición a la API para obtener el detalle de las infracciones de foto rojo, incluyendo las fotos asociadas
   * @param id_infraccion - Id de la infracción a consultar
   * @returns Observable con el detalle de la infracción de foto rojo, incluyendo las fotos asociadas
   */
  getDetailInfractionPhotoRed(id_infraccion: number): Observable<{ data: DetailInfractionPhotoRed[] }> {
    return this.http.get<{ data: DetailInfractionPhotoRed[] }>(`${this.baseUrl}/getDetailInfractionPhotoRed/${id_infraccion}`);
  }

  /**
   * Valida una infracción de foto rojo, actualizando su estado de validación y agregando un comentario de validación
   * @param id id de la infracción a validar
   * @param data datos para validar la infracción, incluyendo el nuevo estado de validación y el comentario de validación
   * @returns Observable con el resultado de la validación de la infracción de foto rojo
   */
  validateInfractionPhotoRed(id: number, data: ValidacionInfraccion): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.baseUrl}/validateInfractionPhotoRed`, { id, ...data });
  }
  
  /**
   * Valida masivamente las infracciones de foto rojo, actualizando su estado de validación y agregando un comentario de validación
   * @param data datos para validar las infracciones, incluyendo el nuevo estado de validación y el comentario de validación
   * @returns Observable con el resultado de la validación masiva de las infracciones de foto rojo
   */
  validateInfractionPhotoRedMassive(data: any): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.baseUrl}/validateInfractionPhotoRedMassive`, data);
  }

  actualizarSentidoMatricula(id_eventoscam: number, matricula: string, sentido: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/actualizarSentidoMatricula`, { id_eventoscam, matricula, sentido });
  }


}